/**
 * Čeština – výchozí jazyk Bloomu.
 *
 * Tenhle soubor je zdroj pravdy: texty se píšou nejdřív sem a ostatní jazyky
 * se podle něj doplňují. Klíč, který tu chybí, nemá smysl mít nikde jinde.
 *
 * Hodnota je text, nebo funkce, když se do textu něco doplňuje. `mnozne`
 * řeší tři české tvary (1 / 2–4 / 5 a víc).
 */
import { mnozne } from '../lib/mnozne';

const cs = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Zpět',
  'obecne.hledat': 'Hledat',
  'obecne.nacitani': 'Načítám…',
  'obecne.zrusit': 'Zrušit',
  'obecne.ulozit': 'Uložit',
  'obecne.odeslat': 'Odeslat',
  'obecne.vice': 'Zobrazit vše',
  'obecne.jazyk': 'Jazyk',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Bezpečný prostor pro trans komunitu, kde můžeš mluvit otevřeně, hledat pomoc a cítit podporu ostatních.',
  'auth.prihlaseni': 'Přihlášení',
  'auth.registrace': 'Registrace',
  'auth.email': 'E-mail',
  'auth.heslo': 'Heslo',
  'auth.emailPriklad': 'váš@email.cz',
  'auth.prihlasitSe': 'Přihlásit se',
  'auth.prihlasuji': 'Přihlašování…',
  'auth.zapomenuteHeslo': 'Zapomněli jste heslo?',
  'auth.presGoogle': 'Přihlásit se přes Google',
  'auth.spatneUdaje': 'Nesprávný e-mail nebo heslo',
  'auth.uspech': 'Přihlášení úspěšné!',
  'auth.googleChyba': 'Přihlášení přes Google se nezdařilo',
  'auth.obnoveniHesla': 'Obnovení hesla',
  'auth.obnoveniOdeslano': 'Pokud je e-mail registrován, obdržíte odkaz pro obnovení hesla.',
  'auth.zpetNaPrihlaseni': 'Zpět na přihlášení',
  'auth.odeslatOdkaz': 'Odeslat odkaz pro obnovení',
  'auth.obnoveniChyba': 'Nepodařilo se odeslat e-mail. Zkuste to znovu.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Ještě kód z aplikace',
  'auth.jesteKodPopis': 'Otevři aplikaci, kterou máš na jednorázové kódy, a opiš šest číslic u účtu Bloom.',
  'auth.kod': 'Kód',
  'auth.zalozniKodNapoveda': 'Nemáš telefon po ruce? Zadej sem místo kódu jeden ze záložních kódů, které sis uložila při zapnutí.',
  'auth.potvrdit': 'Potvrdit',
  'auth.overuji': 'Ověřuji…',
  'auth.kodNesedi': 'Kód nesedí',
  'auth.zalozniDochazeji': (p) => `Záložních kódů už ti zbývá jen ${p.pocet}. Vygeneruj si nové v profilu.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Jak dostat aplikaci Bloom do svého mobilního zařízení',
  'auth.krokyAndroid': [
      'Otevřete tuto stránku v prohlížeči Chrome',
      'Klepněte na ikonu tří teček (⋮) v pravém horním rohu',
      'Zvolte „Přidat na plochu" nebo „Nainstalovat aplikaci"',
      'Potvrďte instalaci',
    ],
  'auth.krokyIos': [
      'Otevřete tuto stránku v prohlížeči Safari',
      'Klepněte na ikonu sdílení (□↑) ve spodní liště',
      'Přejeďte dolů a zvolte „Přidat na plochu"',
      'Potvrďte klepnutím na „Přidat"',
    ],
  'auth.seznamChranene': [
      { silne: 'Nic o členech není veřejné.', text: 'Profily, příběhy, nabídky, otázky, fotky i avatary vydá server jen přihlášenému člověku. Bez přihlášení nejde nic z toho stáhnout ani hromadně sbírat.' },
      { silne: 'Hesla nikdo nezná', text: '— ani my. Ukládají se jako bcrypt otisk, ze kterého se původní heslo zpětně získat nedá.' },
      { silne: 'Soukromé zprávy a přílohy jsou šifrované', text: '(AES + kontrola integrity) už na disku serveru. Když by někdo získal zálohu nebo disk, přečte jen nesmyslné znaky.' },
      { silne: 'Zprávy se samy mažou', text: 'po nastavené době (výchozí 90 dní), včetně hlasovek a fotek. Co tu není, nemůže uniknout.' },
      { silne: 'Tvoje fáze tranzice je soukromá,', text: 'dokud ji sám/sama nezveřejníš. Odškrtnuté kroky v Průvodci nevidí nikdo jiný.' },
      { silne: 'E-mail a telefon', text: 'se ostatním členům nezobrazují.' },
      { silne: '', text: 'Přihlašování je chráněné proti hádání hesel omezením počtu pokusů.' },
      { silne: 'Koncové šifrování zpráv.', text: 'Když si ho zapneš, text i přílohy se zašifrují přímo u tebe v prohlížeči a server dostane jen změť znaků. Klíč se odemyká tvým heslem a nikdy neopustí tvoje zařízení — takže obsah nepřečteme ani my, ani kdyby o něj někdo požádal soudně. Cenou je, že při zapomenutém hesle nepřečteš staré zprávy ani ty.' },
      { silne: '', text: 'Přihlášení nezůstává: po zavření okna i po deseti minutách nečinnosti tě Bloom odhlásí.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadata', text: '— kdo komu a kdy napsal — server vědět musí, aby zprávu doručil. To neskryje ani koncové šifrování a neumí to ani Signal.' },
      { silne: '', text: 'Bloom je webová aplikace, takže si šifrovací kód stáhne z našeho serveru při každém otevření. Kdo by ovládl server, mohl by teoreticky podstrčit upravený kód. Proti tomu pomůže jen aplikace z obchodu, která je podepsaná — proto ji Signal má a webovou verzi ne.' },
      { silne: 'Profily', text: '— přezdívka, bio, avatar — se šifrovat nedají, protože je server musí ukázat ostatním členům.' },
      { silne: '', text: 'Zprávy z doby před zapnutím šifrování zůstávají šifrované jen na disku serveru, ne koncově.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom funguje jako aplikace i offline. Vaše data jsou vždy aktuální.',
  'auth.zabezpeceniTitulek': 'Jak je Bloom zabezpečený',
  'auth.zabezpeceniUvod': 'Bloom je prostor pro trans komunitu, takže se tu potkávají citlivé věci. Tady je bez '
      + 'přikrášlování, co pro jejich ochranu děláme — a co naopak neumíme.',
  'auth.coJeChranene': 'Co je chráněné',
  'auth.coNeumime': 'Co Bloom neumí — a je fér to říct',
  'auth.zabezpeceniZaver': 'Máš-li otázku k soukromí nebo jsi našel/našla slabinu, ozvi se přes „Nahlásit problém" níž. Bereme to vážně.',
  'auth.mvp': 'Aplikace Bloom je v první verzi a postupně ji společně s komunitou vylepšujeme. '
      + 'Pokud narazíte na chybu nebo máte nápad, budeme rádi za zpětnou vazbu.',
  'auth.nahlasitProblem': 'Nahlásit problém',
  'auth.clenu': (p) => mnozne(p.pocet, 'člen', 'členové', 'členů'),
  'auth.prispevku': (p) => mnozne(p.pocet, 'příspěvek', 'příspěvky', 'příspěvků'),
  'auth.odborniku': (p) => mnozne(p.pocet, 'odborník', 'odborníci', 'odborníků'),
  'auth.nabidek': (p) => mnozne(p.pocet, 'nabídka', 'nabídky', 'nabídek'),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Přezdívka (unikátní)',
  'reg.prezdivkaPriklad': 'Minimálně 3 znaky',
  'reg.telefon': 'Telefonní číslo',
  'reg.volitelne': '(volitelné)',
  'reg.heslo': 'Heslo',
  'reg.hesloZnovu': 'Heslo znovu',
  'reg.zajmeno': 'Zájmeno',
  'reg.oMne': 'O mně',
  'reg.oMnePriklad': 'Krátce o sobě…',
  'reg.registrovat': 'Zaregistrovat se',
  'reg.registruji': 'Registrace…',
  'reg.presGoogle': 'Registrovat přes Google',
  'reg.avatar': 'Avatar',
  'reg.neboFoto': 'Nebo nahrajte vlastní foto',
  'reg.nahratFoto': 'Nahrát foto',
  'reg.vlastni': 'Vlastní',
  'reg.zeme': 'Země',
  'reg.kraj': 'Kraj',
  'reg.nechciUvadet': 'Nechci uvádět',
  'reg.cesko': 'Česká republika',
  'reg.svet': 'Svět',

  // skupiny avatarů
  'reg.avatarFem': 'Femininní',
  'reg.avatarMask': 'Maskulinní',
  'reg.avatarNeutr': 'Neutrální',
  'reg.avatarZvirata': 'Zvířata',

  // komunitní heslo
  'reg.komunitniHeslo': 'Komunitní heslo',
  'reg.komunitniHesloPriklad': 'Zadejte komunitní heslo…',
  'reg.komunitniHesloPopis': 'Bloom je soukromý prostor pro trans komunitu. Komunitní heslo ti může předat někdo z komunity.',
  'reg.napisAdminovi': 'Pokud nikoho neznáš, napiš adminovi na',
  'reg.nevimHeslo': 'Nevím komunitní heslo',
  'reg.jakZiskat': 'Komunitní heslo slouží k ochraně soukromého prostoru. Jak ho získat:',
  'reg.krok1': '1. Napište e-mail na',
  'reg.krok2': '2. Krátce se představte a řekněte, jak jste se o Bloom dozvěděli',
  'reg.krok3': '3. Administrátorka vám odpoví co nejdříve',

  // kontrola hesla
  'reg.hesloKratke': 'Heslo musí mít alespoň 8 znaků',
  'reg.hesloMale': 'Heslo musí obsahovat alespoň jedno malé písmeno',
  'reg.hesloVelke': 'Heslo musí obsahovat alespoň jedno velké písmeno',
  'reg.hesloCislo': 'Heslo musí obsahovat alespoň jedno číslo',
  'reg.hesloZnak': 'Heslo musí obsahovat alespoň jeden speciální znak (!@#$%…)',
  'reg.pozadavek8': 'Alespoň 8 znaků',
  'reg.pozadavekVelke': 'Velké písmeno',
  'reg.pozadavekCislo': 'Číslo',
  'reg.pozadavekZnak': 'Speciální znak (!@#$%)',
  'reg.hesloNesouhlasi': 'Hesla se neshodují',
  'reg.prezdivkaKratka': 'Přezdívka musí mít alespoň 3 znaky',
  'reg.hesloPovinne': 'Komunitní heslo je povinné',
  'reg.hotovo': 'Registrace úspěšná! Zkontrolujte svůj e-mail pro ověření účtu.',
  'reg.fotoVelka': 'Obrázek je příliš velký (max 2 MB)',
  'reg.chyba': 'Registrace se nezdařila',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Nikdo tu nemusí být dokonalý. Bloom je prostor, kde každý může být sám sebou — '
      + 'kde můžete sdílet své zkušenosti, ptát se a pomáhat ostatním. Bez odsuzování a bez předsudků.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': '',
  'domu.vitej': 'Vítej,',
  'domu.vCislech': 'Bloom v číslech',
  'domu.noveVKomunite': 'Nově v komunitě?',
  'domu.noveVKomunitePopis1': 'Nemusíš být veřejně vidět. Nemusíš mít fotku. Nemusíš být out.',
  'domu.noveVKomunitePopis2': 'Bloom je prostor, kde můžeš začít svým tempem.',
  'domu.rozcestnik1': 'Jsem tu poprvé',
  'domu.rozcestnik2': 'Nevím kde začít',
  'domu.rozcestnik3': 'Chci zůstat anonymní',
  'domu.rozcestnik4': 'Hledám odborníka',
  'domu.rozcestnik5': 'Chci si jen číst zkušenosti',
  'domu.otazky': 'Máš otázky nebo chceš vědět více? Napiš nám na',
  'domu.doporucujeme': 'Doporučujeme',
  'domu.odbornici': 'Odborníci',
  'domu.noviClenove': 'Noví členové komunity',
  'domu.zadniNovi': 'Zatím žádní noví členové',
  'domu.nejnovejsiOtazky': 'Nejnovější otázky',
  'domu.zadneOtazky': 'Zatím žádné otázky.',
  'domu.nejlepeHodnoceni': 'Nejlépe hodnocení odborníci',
  'domu.zadniHodnoceni': 'Zatím žádní hodnocení odborníci',
  'domu.zadneAktuality': 'Zatím nejsou žádné aktuality',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Nabídněte své dovednosti a získejte služby od ostatních.',
  'domu.dlazdice.specialists': 'Najděte ověřené odborníky od psychologů po plastické chirurgy.',
  'domu.dlazdice.legal': 'Právní pomoc, články a odpovědi na vaše otázky.',
  'domu.dlazdice.nearby': 'Služby a odborníci ve vašem okolí.',

  // počty
  'domu.pocetClenu': (p) => `${mnozne(p.pocet, 'člen', 'členové', 'členů')} komunity`,
  'domu.pocetZkusenosti': (p) => mnozne(p.pocet, 'sdílená zkušenost', 'sdílené zkušenosti', 'sdílených zkušeností'),
  'domu.pocetOdborniku': (p) => mnozne(p.pocet, 'ověřený odborník', 'ověření odborníci', 'ověřených odborníků'),
  'domu.pocetNabidek': (p) => `${mnozne(p.pocet, 'nabídka', 'nabídky', 'nabídek')} vzájemné pomoci`,

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Domů',
  'nav.news': 'Aktuality',
  'nav.stories': 'Zkušenosti komunity',
  'nav.mapaSveta': 'Mapa světa',
  'nav.support': 'Vzájemná podpora',
  'nav.specialists': 'Trans-friendly odborníci',
  'nav.legal': 'Právní poradna',
  'nav.pageants': 'Soutěže',
  'nav.nearby': 'V mém okolí',
  'nav.hledat': 'Hledat v Bloom',
  'nav.hledatPlaceholder': 'Hledat lidi, odborníky, články…',
  'nav.zpravy': 'Zprávy',
  'nav.profil': 'Můj profil',
  'nav.mojeCesta': 'Moje cesta',
  'nav.administrace': 'Administrace',
  'nav.odhlasit': 'Odhlásit se',
  'nav.vsechnyVysledky': (p) => `Zobrazit všechny výsledky pro „${p.dotaz}"`,
  'nav.overEmail': 'Ověř si e-mail',
  'nav.menu': 'Nabídka',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom ve světě',
  'svet.podtitulek': 'Klikni na zemi a podívej se, co v ní komunita zatím shromáždila.',
  'svet.hledatZemi': 'Hledat zemi…',
  'svet.vsechnyZeme': 'Všechny země',
  'svet.jenSObsahem': 'Jen země s obsahem',
  'svet.nicNenalezeno': 'Žádná země neodpovídá.',
  'svet.zaznamu': (p) => `${p.pocet} ${mnozne(p.pocet, 'záznam', 'záznamy', 'záznamů')}`,
  'svet.prazdnaZeme': 'Zatím nic',
  'svet.kontinent': 'Světadíl',
  'svet.celySvet': 'Celý svět',
  'svet.vse': 'Vše',
  'svet.zacniDomovem': 'Začni tím, že klikneš na zemi, kde to máš domů. Vybrat můžeš i ze seznamu pod mapou.',
  'svet.zkoumej': 'Klikni na zemi a podívej se, co v ní Bloom má. Můžeš zkoumat kdekoliv — '
      + 'tvoje domovská země se tím nezmění.',
  'svet.domov': 'Domov',
  'svet.zrusitDomov': 'Zrušit domovskou zemi',
  'svet.nastavitDomov': 'Nastavit jako domovskou zemi',
  'svet.zeSveta': 'Ze světa',
  'svet.coSeChysta': 'Co se chystá',
  'svet.souteze': 'Soutěže s otevřenými přihláškami',
  'svet.noveOrganizace': 'Nové organizace',
  'svet.kdeJizNeco': 'Kde už Bloom něco má',
  'svet.hledatZemiPopisek': 'Hledat zemi',
  'svet.nicNeodpovida': 'Nic neodpovídá. Zkus jiné hledání.',
  'svet.napovedaKMape': 'Mapa se dá posouvat tažením a přibližovat kolečkem nebo tlačítky. '
      + 'Nemusíš ji používat — níž je hledání i celý seznam zemí.',
  'svet.tvujBloom': (p) => `Tvůj Bloom v zemi ${p.zeme}`,
  'svet.tvojeDomovska': 'tvoje domovská země',
  'svet.zemi': (p) => `${p.pocet} ${mnozne(p.pocet, 'země', 'země', 'zemí')}`,
  'svet.chyba': 'Nepodařilo se načíst země. Zkuste stránku načíst znovu.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${mnozne(p.pocet, 'odborník', 'odborníci', 'odborníků')}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${mnozne(p.pocet, 'organizace', 'organizace', 'organizací')}`,
  'svet.pocet.events': (p) => `${p.pocet} ${mnozne(p.pocet, 'akce', 'akce', 'akcí')}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${mnozne(p.pocet, 'soutěž', 'soutěže', 'soutěží')}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${mnozne(p.pocet, 'odkaz', 'odkazy', 'odkazů')}`,

  // světadíly
  'kontinent.europe': 'Evropa',
  'kontinent.asia': 'Asie',
  'kontinent.africa': 'Afrika',
  'kontinent.north_america': 'Severní Amerika',
  'kontinent.south_america': 'Jižní Amerika',
  'kontinent.oceania': 'Oceánie',
  'kontinent.antarctica': 'Antarktida',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Trans soutěže krásy z celého světa. Nahoře jsou ty, na které se dá ještě přihlásit.',
  'souteze.hledat': 'Hledat soutěž…',
  'souteze.zadne': 'Žádné soutěže zatím nemáme. Znáš nějakou? Pošli návrh.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Otevřít ${p.zeme}`,
  'nahled.zavrit': 'Zavřít náhled',
  'nahled.jenInformace': 'Zatím tu máme jen informace o zemi.',
  'nahled.zatimNic': 'Kontakty, organizace ani akce tu ještě nemáme. Znáš něco? Pošli návrh.',

  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom v zemi ${p.zeme}`,
  'zeme.podtitulek': (p) => `Co komunita v zemi ${p.zeme} zatím shromáždila.`,
  'zeme.prazdna': 'Tady Bloom teprve roste. Můžeš být první, kdo sem něco přidá.',
  'zeme.mapaSveta': 'Mapa světa',
  'zeme.navrhnout': 'Navrhnout záznam',
  'zeme.domovska': 'Tvoje domovská země',
  'zeme.nastavitDomovskou': 'Nastavit jako domovskou',
  'zeme.kdeToJe': 'Kde to je',
  'zeme.coTuBude': 'Co tu bude',
  'zeme.zatimPrazdne': 'zatím prázdné',
  'zeme.pripravujeme': 'připravujeme',
  'zeme.zobrazitVse': (p) => `Zobrazit vše (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom v téhle zemi teprve roste',
  'zeme.rostePopis': 'Zatím tu nic nemáme. Znáš tu organizaci, akci nebo užitečný kontakt? '
      + 'Pošli návrh — projde kontrolou a pak se tu objeví.',
  'zeme.jinouZemi': 'Prohlédnout jiné země',
  'zeme.bezKontaktu': 'Kontakty a organizace tu zatím nemáme.',
  'zeme.bezKontaktuPopis': 'Znáš tu někoho nebo něco užitečného? Pošli návrh — projde kontrolou '
      + 'a pak se tu objeví.',
  'zeme.neznama': 'Takovou zemi neznáme.',
  'zeme.chyba': 'Zemi se nepodařilo načíst.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Odborníci a kliniky',
  'sekce.specialists.popis': 'Lékaři, kliniky a další odborníci, se kterými má komunita zkušenost.',
  'sekce.organizations': 'Organizace',
  'sekce.organizations.popis': 'Spolky, neziskovky a podpůrné skupiny.',
  'sekce.events': 'Akce',
  'sekce.events.popis': 'Setkání, Pride, workshopy a konference.',
  'sekce.pageants': 'Soutěže',
  'sekce.pageants.popis': 'Trans soutěže krásy a jejich termíny.',
  'sekce.resources': 'Rozcestník',
  'sekce.resources.popis': 'Praktické informace pro tuhle zemi.',
  'sekce.community': 'Komunita',
  'sekce.community.popis': 'Lidé a skupiny v téhle zemi.',
  'sekce.legal': 'Právní poradna',
  'sekce.legal.popis': 'Informace a podpora pro trans komunitu',
  'sekce.support': 'Vzájemná podpora',
  'sekce.support.popis': 'Nab\u00eddn\u011bte sv\u00e9 dovednosti a z\u00edskejte pomoc od ostatn\u00edch \u010dlen\u016f komunity',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Hledat v této zemi…',
  'vypis.vsechnyKategorie': 'Všechny kategorie',
  'vypis.kategorie': 'Kategorie',
  'vypis.celaZeme': 'Celá země',
  'vypis.navrhnout': 'Navrhnout',
  'vypis.nicNeodpovida': 'Nic neodpovídá. Zkus jiné hledání nebo zruš filtr.',
  'vypis.zadneZaznamy': (p) => `V zemi ${p.zeme} zatím žádné záznamy nemáme.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${mnozne(p.pocet, 'záznam', 'záznamy', 'záznamů')}`,
  'vypis.predchozi': 'Předchozí',
  'vypis.dalsi': 'Další',
  'vypis.chyba': 'Záznamy se nepodařilo načíst.',
  'vypis.neznamyDruh': 'Takový druh záznamů neznáme.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Zpět na ${p.zeme}`,
  'detail.kontakty': 'Kontakty a odkazy',
  'detail.podrobnosti': 'Podrobnosti',
  'detail.zacatek': 'Začátek',
  'detail.termin': 'Termín',
  'detail.uzaverka': 'Uzávěrka přihlášek',
  'detail.prihlaska': 'Přihláška',
  'detail.strankaAkce': 'Stránka akce',
  'detail.web': 'Web',
  'detail.konec': 'Konec',
  'detail.stavRocniku': 'Stav ročníku',
  'detail.oblasti': 'Oblasti činnosti',
  'detail.coNabizi': 'Co nabízí',
  'detail.kategorie': 'Kategorie',
  'detail.jazyky': 'Jazyky',
  'detail.vitezove': 'Dřívější vítězky a vítězové',
  'detail.kdoSeMuze': 'Kdo se může přihlásit',
  'detail.poradatel': 'Pořadatel',
  'detail.poplatek': 'Poplatek',
  'detail.tema': 'Téma',
  'detail.forma.offline': 'Osobně',
  'detail.forma.online': 'Online',
  'detail.forma.hybrid': 'Osobně i online',
  'detail.rozsah.local': 'Místní',
  'detail.rozsah.national': 'Celostátní',
  'detail.rozsah.international': 'Mezinárodní',
  'detail.rocnik.upcoming': 'Chystá se',
  'detail.rocnik.registration_open': 'Přihlášky otevřené',
  'detail.rocnik.registration_closed': 'Přihlášky uzavřené',
  'detail.rocnik.completed': 'Proběhlo',
  'detail.zdroj': (p) => `Zdroj informace: ${p.zdroj}`,
  'detail.upraveno': (p) => `Naposledy upraveno: ${p.datum}`,
  'detail.overeno': 'Ověřeno, že záznam odpovídá skutečnosti. Neznamená to doporučení Bloomu.',
  'detail.neovereno': 'Záznam zatím není ověřený. Údaje se mohly změnit — ověř si je prosím u zdroje.',
  'detail.nenalezen': 'Takový záznam neznáme. Mohl být smazaný nebo ještě čeká na kontrolu.',
  'detail.chyba': 'Záznam se nepodařilo načíst.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Co tu platí',
  'profil.name_change': 'Změna jména',
  'profil.gender_marker': 'Změna úředního pohlaví',
  'profil.surgery_required': 'Podmínka operace',
  'profil.healthcare': 'Dostupnost péče',
  'profil.legal_protection': 'Ochrana před diskriminací',
  'profil.safety': 'Bezpečnost',
  'profil.stav.yes': 'Ano',
  'profil.stav.limited': 'Částečně',
  'profil.stav.no': 'Ne',
  'profil.stav.unknown': 'Nevíme',
  'profil.zdroj': 'Zdroj',
  'profil.zdrojZRoku': (p) => `zdroj z roku ${p.rok}`,
  'profil.overeno': (p) => `Ověřeno ${p.datum}`,
  'profil.zmena': 'Nedávná změna',
  'profil.odKdy': (p) => `platí od ${p.datum}`,
  'profil.doklady': 'Doklady',
  'profil.zakon': 'zákon nebo soud',
  'profil.upozorneni': 'Tohle není právní poradenství. Zákony se mění a hodně věcí závisí na '
      + 'konkrétní situaci — ověř si je prosím u zdroje nebo u organizace v dané '
      + 'zemi, než se podle nich rozhodneš.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Navrhnout ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Návrh projde kontrolou, než se objeví v Bloomu. Stačí vyplnit, co víš — '
      + 'zbytek doplníme.',
  'navrh.jednotne.organizations': 'organizaci',
  'navrh.jednotne.events': 'akci',
  'navrh.jednotne.pageants': 'soutěž',
  'navrh.jednotne.resources': 'rozcestník',
  'navrh.popis.organizations': 'Spolek, nezisková organizace nebo podpůrná skupina.',
  'navrh.popis.events': 'Setkání, Pride, workshop, konference.',
  'navrh.popis.pageants': 'Trans soutěž krásy – termín, přihlášky, pořadatel.',
  'navrh.popis.resources': 'Praktická informace – zdravotní péče, právo, doklady, kontakty.',
  'navrh.nazev': 'Název',
  'navrh.popisPole': 'Popis',
  'navrh.zeme': 'Země',
  'navrh.mesto': 'Město',
  'navrh.adresa': 'Adresa',
  'navrh.web': 'Web',
  'navrh.email': 'E-mail',
  'navrh.telefon': 'Telefon',
  'navrh.odkudVis': 'Odkud to víš',
  'navrh.odkudVisPriklad': 'např. jejich web, byla jsem tam…',
  'navrh.vyberte': '— vyberte —',
  'navrh.forma': 'Forma',
  'navrh.rozsah': 'Rozsah',
  'navrh.platiPro': 'Platí pro',
  'navrh.platnost.global': 'Celý svět',
  'navrh.platnost.country': 'Zemi',
  'navrh.platnost.region': 'Oblast',
  'navrh.platnost.city': 'Město',
  'navrh.odkazAkce': 'Odkaz na akci',
  'navrh.odkazPrihlaska': 'Odkaz na přihlášku',
  'navrh.odkazy': 'Odkazy',
  'navrh.text': 'Text',
  'navrh.odeslat': 'Odeslat návrh',
  'navrh.odesilam': 'Odesílám…',
  'navrh.chyba': 'Návrh se nepodařilo odeslat',
  'navrh.dikyTitulek': 'Díky, máme to',
  'navrh.dikyPopis': 'Návrh jsme přijali. Někdo z nás ho projde a pak se objeví v Bloomu. '
      + 'Nezveřejňuje se automaticky.',
  'navrh.zavrit': 'Zavřít',
  'navrh.seznamNapoveda': 'Odděl položky čárkou.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Patří vám tahle ${p.druh}?`,
  'prevzeti.popis': 'Můžete si profil převzít do vlastní správy a udržovat údaje aktuální. '
      + 'Žádost nejdřív projde kontrolou.',
  'prevzeti.tlacitko': 'Převzít profil',
  'prevzeti.spravujes': 'Tenhle profil spravuješ. Údaje můžeš kdykoli opravit — změny se projeví hned.',
  'prevzeti.upravit': 'Upravit údaje',
  'prevzeti.spravujeSama': (p) => `Profil spravuje ${p.druh} sama.`,
  'prevzeti.ceka': 'Tvoji žádost o převzetí profilu jsme přijali a posuzujeme ji.',
  'prevzeti.formulacTitulek': (p) => `Převzít profil — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Než profil předáme, potřebujeme vědět, že k organizaci opravdu patříte. '
      + 'Žádost projde kontrolou, hned se nic nezmění.',
  'prevzeti.role': 'Čím v organizaci jste?',
  'prevzeti.rolePriklad': 'např. koordinátorka, předseda spolku',
  'prevzeti.doklad': 'Jak se to dá ověřit?',
  'prevzeti.dokladPriklad': 'např. jsem uvedená na webu organizace v sekci kontakty; nebo napište z oficiální adresy',
  'prevzeti.dokladNapoveda': 'Stačí odkaz na stránku, kde jste uvedení, nebo oficiální adresa organizace, '
      + 'ze které se ozvete.',
  'prevzeti.kontakt': 'Kontakt na vás',
  'prevzeti.kontaktPriklad': 'e-mail nebo telefon',
  'prevzeti.dalsi': 'Cokoli dalšího',
  'prevzeti.nepovinne': '(nepovinné)',
  'prevzeti.odeslat': 'Odeslat žádost',
  'prevzeti.odesilam': 'Odesílám…',
  'prevzeti.vyplnObe': 'Napiš prosím, čím v organizaci jsi a jak se to dá ověřit.',
  'prevzeti.prijato': 'Děkujeme. Žádost jsme přijali a ozveme se po posouzení.',
  'prevzeti.chyba': 'Žádost se nepodařilo odeslat.',
  'prevzeti.upravaTitulek': (p) => `Úprava profilu — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Název a místo tady nejsou schválně: podle nich se záznam hledá a řadí. '
      + 'Když se změnily, napište nám a upravíme je.',
  'prevzeti.popisPole': 'Popis',
  'prevzeti.email': 'E-mail',
  'prevzeti.telefon': 'Telefon',
  'prevzeti.web': 'Web',
  'prevzeti.ulozeno': 'Uloženo.',
  'prevzeti.ukladam': 'Ukládám…',
  'prevzeti.chybaUlozeni': 'Uložit se to nepovedlo.',
  'prevzeti.druh.organizations': 'organizace',
  'prevzeti.druh.events': 'akce',
  'prevzeti.druh.pageants': 'soutěž',
  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Upravte sv\u00e9 \u00fadaje a nastaven\u00ed',
  'profil.overeny': 'Ov\u011b\u0159en\u00fd',
  'profil.neovereny': 'Neov\u011b\u0159en\u00fd',
  'profil.overteEmail': 'Ov\u011b\u0159te sv\u016fj e-mail. Neov\u011b\u0159en\u00fd u\u017eivatel m\u00e1 omezen\u00e1 pr\u00e1va.',
  'profil.emailOdeslan': 'Ov\u011b\u0159ovac\u00ed e-mail odesl\u00e1n!',
  'profil.emailChyba': 'Nepoda\u0159ilo se odeslat e-mail',
  'profil.odeslano': 'Odesl\u00e1no!',
  'profil.overeniOdbornika': 'Ov\u011b\u0159en\u00ed odborn\u00edka nebo pr\u00e1vn\u00edka',
  'profil.pracujeteVOboru': 'Pracujete v oboru? Z\u00edskejte ov\u011b\u0159en\u00fd \u0161t\u00edtek.',
  'profil.zadostOdeslana': '\u017d\u00e1dost odesl\u00e1na',
  'profil.pozadatOOvereni': 'Po\u017e\u00e1dat o ov\u011b\u0159en\u00ed',
  'profil.zadostTitulek': '\u017d\u00e1dost o ov\u011b\u0159en\u00ed odborn\u00edka / pr\u00e1vn\u00edka',
  'profil.zadostPopis': 'Vypl\u0148te \u00fadaje k \u017e\u00e1dosti o ov\u011b\u0159en\u00ed. Posoud\u00ed ji spr\u00e1vci.',
  'profil.pozadovanaRole': 'Po\u017eadovan\u00e1 role',
  'profil.roleOdbornik': 'Odborn\u00edk',
  'profil.rolePravnik': 'Pr\u00e1vn\u00edk',
  'profil.specializace': 'Specializace',
  'profil.odkazNaProfil': 'Odkaz na profesn\u00ed profil',
  'profil.zpravaProAdmina': 'Kr\u00e1tk\u00e1 zpr\u00e1va pro admina',
  'profil.odesilam': 'Odes\u00edl\u00e1m\u2026',
  'profil.odeslatZadost': 'Odeslat \u017e\u00e1dost o ov\u011b\u0159en\u00ed',
  'profil.vyplnteSpecializaci': 'Vypl\u0148te pros\u00edm specializaci',
  'profil.zadostUspech': '\u017d\u00e1dost o ov\u011b\u0159en\u00ed byla odesl\u00e1na!',
  'profil.zadostChyba': 'Chyba p\u0159i odes\u00edl\u00e1n\u00ed \u017e\u00e1dosti',

  // bezpečnost
  'bezp.titulek': 'Bezpe\u010dnost',
  'bezp.sifrovaniZapnuto': (p) => `\u0160ifrov\u00e1n\u00ed zpr\u00e1v je zapnut\u00e9${p.odemceno ? ' a odem\u010den\u00e9' : ' (v t\u00e9to z\u00e1lo\u017ece zam\u010den\u00e9)'}.`,
  'bezp.sifrovaniVypnuto': '\u0160ifrov\u00e1n\u00ed zpr\u00e1v zat\u00edm nem\u00e1\u0161 zapnut\u00e9.',
  'bezp.sifrovaniKde': 'Zap\u00edn\u00e1 a odemyk\u00e1 se na str\u00e1nce Zpr\u00e1vy.',
  'bezp.sifrovaniKdeVypnute': 'Zapne\u0161 ho na str\u00e1nce Zpr\u00e1vy, u kterékoli konverzace.',
  'bezp.zmenaHesla': 'Zm\u011bna hesla',
  'bezp.zmenaHeslaSifrovani': 'M\u00e1\u0161 zapnut\u00e9 \u0161ifrov\u00e1n\u00ed, tak\u017ee se p\u0159i zm\u011bn\u011b hesla p\u0159ebal\u00ed i kl\u00ed\u010d ke zpr\u00e1v\u00e1m. '
      + 'Proto je pot\u0159eba st\u00e1vaj\u00edc\u00ed heslo \u2014 bez n\u011bj by kl\u00ed\u010d otev\u0159\u00edt ne\u0161lo a o zpr\u00e1vy bys p\u0159i\u0161la.',
  'bezp.stavajiciHeslo': 'St\u00e1vaj\u00edc\u00ed heslo',
  'bezp.noveHeslo': 'Nov\u00e9 heslo',
  'bezp.noveHesloZnovu': 'Nov\u00e9 heslo znovu',
  'bezp.pozadavky': 'Aspo\u0148 8 znak\u016f, velk\u00e9 i mal\u00e9 p\u00edsmeno, \u010d\u00edslice a jeden zvl\u00e1\u0161tn\u00ed znak.',
  'bezp.zmenitHeslo': 'Zm\u011bnit heslo',
  'bezp.menim': 'M\u011bn\u00edm\u2026',
  'bezp.hesloNeshoda': 'Nov\u00e1 hesla se neshoduj\u00ed.',
  'bezp.vyplnObe': 'Vypl\u0148 pros\u00edm ob\u011b hesla.',
  'bezp.stareNesedi': 'St\u00e1vaj\u00edc\u00ed heslo nesed\u00ed \u2014 kl\u00ed\u010d ke zpr\u00e1v\u00e1m by se ztratil, tak jsme nic nem\u011bnili.',
  'bezp.zmenenoSKlicem': 'Heslo zm\u011bn\u011bno. Kl\u00ed\u010d ke zpr\u00e1v\u00e1m je p\u0159ebalen\u00fd, star\u00e9 zpr\u00e1vy z\u016fst\u00e1vaj\u00ed \u010diteln\u00e9.',
  'bezp.zmeneno': 'Heslo zm\u011bn\u011bno.',
  'bezp.zmenaChyba': 'Heslo se nepoda\u0159ilo zm\u011bnit.',
  'bezp.nepamatujes': 'Nepamatuje\u0161 si heslo ke kl\u00ed\u010di?',
  'bezp.zahoditPopis': 'Kl\u00ed\u010d jde zahodit a za\u010d\u00edt znovu. Dosud za\u0161ifrovan\u00e9 zpr\u00e1vy t\u00edm ale p\u0159ijdou nen\u00e1vratn\u011b '
      + '\u2014 p\u0159e\u010d\u00edst je nedok\u00e1\u017ee nikdo, ani my. Pr\u00e1v\u011b proto je to bezpe\u010dn\u00e9.',
  'bezp.zahodit': 'Zahodit kl\u00ed\u010de a za\u010d\u00edt znovu',
  'bezp.zahoditPotvrzeni': 'Opravdu zahodit kl\u00ed\u010de?\n\nV\u0161echny dosud za\u0161ifrovan\u00e9 zpr\u00e1vy t\u00edm p\u0159ijde\u0161 nen\u00e1vratn\u011b '
      + '\u2014 p\u0159e\u010d\u00edst je nedok\u00e1\u017ee nikdo, ani my. D\u011bl\u00e1 se to jen tehdy, kdy\u017e si nepamatuje\u0161 heslo, '
      + 'kter\u00fdm jsi \u0161ifrov\u00e1n\u00ed zap\u00ednala.',
  'bezp.klicSmazan': 'Kl\u00ed\u010de smaz\u00e1ny. Na\u010dti pros\u00edm str\u00e1nku znovu.',
  'bezp.nepovedlo': 'Nepovedlo se to.',
  'bezp.prohlizecNeumi': 'Tenhle prohl\u00ed\u017ee\u010d neum\u00ed \u0161ifrov\u00e1n\u00ed, kter\u00e9 Bloom pou\u017e\u00edv\u00e1.',

  'profil.mujProfil': 'Můj profil',
  'profil.specializacePriklad': 'např. psycholog, sexuolog, advokát…',
  'profil.zpravaPriklad': 'Např. odkaz na registraci v komoře, web ordinace…',
  'profil.overeniUvod': 'Chcete být na Bloom ověřený odborník nebo právník? Pošlete žádost o ověření. '
      + 'Profil musí odpovídat vaší skutečné profesi.',

  'profil.oborPriklad': 'např. plastická chirurgie, rodinné právo…',
  'profil.nepovinnyText': 'Nepovinný doplňující text…',

  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Dvouf\u00e1zov\u00e9 p\u0159ihl\u00e1\u0161en\u00ed',
  'dvf.zapnuto': (p) => `Zapnut\u00e9. Zb\u00fdv\u00e1 ti ${p.pocet} z\u00e1lo\u017en\u00edch k\u00f3d\u016f.`,
  'dvf.vypnuto': 'K heslu se nav\u00edc op\u00ed\u0161e \u0161estim\u00edstn\u00fd k\u00f3d z aplikace v telefonu.',
  'dvf.chraniA': 'Chr\u00e1n\u00ed',
  'dvf.chraniPrihlaseni': 'p\u0159ihl\u00e1\u0161en\u00ed',
  'dvf.chraniB': ': kdo zn\u00e1 tvoje heslo, ale nem\u00e1 tv\u016fj telefon, dovnit\u0159 nevejde.',
  'dvf.nechrani': '\u0160ifrovan\u00e9 zpr\u00e1vy nechr\u00e1n\u00ed',
  'dvf.nechraniPopis': ' \u2014 ty se odemykaj\u00ed heslem p\u0159\u00edmo u tebe v prohl\u00ed\u017ee\u010di a server u toho nen\u00ed.',
  'dvf.ulozKody': 'Ulo\u017e si t\u011bchto deset z\u00e1lo\u017en\u00edch k\u00f3d\u016f',
  'dvf.ulozKodyPopis1': 'Ka\u017ed\u00fd se d\u00e1 pou\u017e\u00edt jednou a jsou to jedin\u00e1 cesta dovnit\u0159, kdybys p\u0159i\u0161la o telefon.',
  'dvf.znovuNeukaze': 'Znovu ti je nikdo neuk\u00e1\u017ee',
  'dvf.ulozKodyPopis2': ' \u2014 ulo\u017een\u00e9 m\u00e1me jen jejich otisky.',
  'dvf.zkopirovat': 'Zkop\u00edrovat',
  'dvf.ulozilaJsem': 'Ulo\u017eila jsem si je',
  'dvf.zkopirovano': 'Zkop\u00edrov\u00e1no.',
  'dvf.kopieChyba': 'Zkop\u00edrovat se to nepovedlo, opi\u0161 je pros\u00edm ru\u010dn\u011b.',
  'dvf.zapnout': 'Zapnout dvouf\u00e1zov\u00e9 p\u0159ihl\u00e1\u0161en\u00ed',
  'dvf.pripravuji': 'P\u0159ipravuji\u2026',
  'dvf.nactiKod': 'Na\u010dti tenhle k\u00f3d v aplikaci na jednor\u00e1zov\u00e9 k\u00f3dy \u2014 t\u0159eba Google Authenticator, Authy, 1Password nebo Aegis.',
  'dvf.qrNejde': 'QR k\u00f3d nejde na\u010d\u00edst?',
  'dvf.zadejRucne': 'Zadej v aplikaci ru\u010dn\u011b tenhle kl\u00ed\u010d:',
  'dvf.opisKod': 'Opi\u0161 k\u00f3d, kter\u00fd se v aplikaci objevil',
  'dvf.zapnoutKratce': 'Zapnout',
  'dvf.overuji': 'Ov\u011b\u0159uji\u2026',
  'dvf.noveKody': 'Nov\u00e9 z\u00e1lo\u017en\u00ed k\u00f3dy',
  'dvf.vypnout': 'Vypnout',
  'dvf.noveKodyPopis': 'Nov\u00e1 sada nahrad\u00ed tu starou \u2014 dosavadn\u00ed z\u00e1lo\u017en\u00ed k\u00f3dy p\u0159estanou platit.',
  'dvf.kodZAplikace': 'K\u00f3d z aplikace',
  'dvf.vygenerovat': 'Vygenerovat',
  'dvf.vypnutiPopis': 'Vypnut\u00ed chce heslo i platn\u00fd k\u00f3d. Oboj\u00ed schv\u00e1ln\u011b: jinak by 2FA sundal kdokoli, kdo se dostane k odem\u010den\u00e9mu prohl\u00ed\u017ee\u010di.',
  'dvf.kodNeboZalozni': 'K\u00f3d z aplikace nebo z\u00e1lo\u017en\u00ed k\u00f3d',
  'dvf.vypinam': 'Vyp\u00edn\u00e1m\u2026',
  'dvf.vypnoutCele': 'Vypnout dvouf\u00e1zov\u00e9 p\u0159ihl\u00e1\u0161en\u00ed',
  'dvf.vypnuto2': 'Dvouf\u00e1zov\u00e9 p\u0159ihl\u00e1\u0161en\u00ed vypnuto.',
  'dvf.kodNesedi': 'K\u00f3d nesed\u00ed.',
  'dvf.nepovedlo': 'Nepovedlo se to.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profil aktualizov\u00e1n!',
  'pf.chyba': 'Nepoda\u0159ilo se aktualizovat profil',
  'pf.fotkaNahrana': 'Fotografie nahr\u00e1na!',
  'pf.fotkaChyba': 'Nepoda\u0159ilo se nahr\u00e1t obr\u00e1zek',
  'pf.fotkaVelka': 'Obr\u00e1zek je p\u0159\u00edli\u0161 velk\u00fd (max 5 MB)',
  'pf.oznameniUlozeno': 'Nastaven\u00ed ozn\u00e1men\u00ed ulo\u017eeno!',
  'pf.oznameniChyba': 'Nepoda\u0159ilo se ulo\u017eit nastaven\u00ed',
  'pf.zruseno': 'Profil byl zru\u0161en',
  'pf.zruseniChyba': 'Nepoda\u0159ilo se zru\u0161it profil',
  'pf.zruseniPotvrzeni': 'Opravdu chcete zru\u0161it sv\u016fj profil? Tato akce je nevratn\u00e1 a v\u0161echna va\u0161e data budou smaz\u00e1na.',
  'pf.urlFacebook': 'Facebook URL mus\u00ed za\u010d\u00ednat https://',
  'pf.urlInstagram': 'Instagram URL mus\u00ed za\u010d\u00ednat https://',
  'pf.urlLinkedin': 'LinkedIn URL mus\u00ed za\u010d\u00ednat https://',
  'pf.ukladam': 'Ukl\u00e1d\u00e1m\u2026',
  'pf.ulozitOznameni': 'Ulo\u017eit nastaven\u00ed ozn\u00e1men\u00ed',
  'pf.oznameniZpravy': 'P\u0159\u00edm\u00e9 zpr\u00e1vy',
  'pf.oznameniAdmin': 'Nov\u00e1 zpr\u00e1va od administr\u00e1tora',
  'pf.oznameniUzivatel': 'Nov\u00e1 zpr\u00e1va od jin\u00e9ho u\u017eivatele',
  'pf.oznameniPodpora': 'Nov\u00fd p\u0159\u00edsp\u011bvek v sekci Podpora',
  'pf.oznameniNabidky': 'Nab\u00eddky a popt\u00e1vky',

  // odznaky
  'pf.odznakAdmin': 'Administr\u00e1tor',
  'pf.odznakPravnik': 'Pr\u00e1vn\u00edk',
  'pf.odznakSpecialista': 'Ov\u011b\u0159en\u00fd specialista',
  'pf.odznakClen': 'Ov\u011b\u0159en\u00fd \u010dlen komunity',
  'pf.odznakPomocnik': 'Aktivn\u00ed pomocn\u00edk',
  'pf.odznakDuveryhodny': 'D\u016fv\u011bryhodn\u00fd u\u017eivatel',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Fotografie p\u0159id\u00e1na do galerie!',
  'gal.smazano': 'Fotografie smaz\u00e1na',
  'gal.hesloKratke': 'Heslo galerie mus\u00ed m\u00edt alespo\u0148 4 znaky',
  'gal.nahraniChyba': 'Nepoda\u0159ilo se nahr\u00e1t fotografii',
  'gal.mazaniChyba': 'Nepoda\u0159ilo se smazat fotografii',
  'gal.souborVelky': 'Soubor je p\u0159\u00edli\u0161 velk\u00fd (max 5 MB)',
  'gal.ulozitNastaveni': 'Ulo\u017eit nastaven\u00ed',
  'gal.soukromiGalerie': 'Soukromí galerie',
  'gal.verejnaGalerie': 'Veřejná galerie',
  'gal.hesloPopis': 'N\u00e1v\u0161t\u011bvn\u00edci budou muset zadat toto heslo pro zobrazen\u00ed galerie.',
  'gal.pridat': 'P\u0159idat fotografii nebo video',
  'gal.prazdna': 'Zat\u00edm \u017e\u00e1dn\u00e9 fotografie v galerii',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Kde se nach\u00e1z\u00edm?',
  'cesta.popis': 'Sd\u00edlej svou f\u00e1zi tranzice, pokud chce\u0161 \u2013 nebo si ji nech jen pro sebe.',
  'cesta.soukroma': 'F\u00e1ze je soukrom\u00e1',
  'cesta.viditelna': 'F\u00e1ze je viditeln\u00e1 ostatn\u00edm',
  'cesta.jenTy': 'Pouze ty vid\u00ed\u0161 svou f\u00e1zi',
  'cesta.mohouNajit': 'Ostatn\u00ed t\u011b mohou naj\u00edt p\u0159es \u201eNaj\u00edt lidi v podobn\u00e9 f\u00e1zi"',
  'cesta.poznamka': 'Osobn\u00ed pozn\u00e1mka',
  'cesta.volitelna': '(voliteln\u00e1)',
  'cesta.poznamkaPriklad': 'Cokoliv, co chce\u0161 sd\u00edlet nebo si zapamatovat\u2026',
  'cesta.najitPodobne': 'Naj\u00edt lidi v podobn\u00e9 f\u00e1zi',
  'cesta.hledam': 'Hled\u00e1m\u2026',
  'cesta.ulozit': 'Ulo\u017eit moji cestu',
  'cesta.ulozeno': 'Va\u0161e cesta byla ulo\u017eena!',
  'cesta.vyberteFazi': 'Vyberte pros\u00edm f\u00e1zi cesty',
  'cesta.chyba': 'Nepoda\u0159ilo se ulo\u017eit',

  'pf.socialniSite': 'Soci\u00e1ln\u00ed s\u00edt\u011b',
  'pf.avatarFoto': 'Avatar / Profilov\u00e1 fotka',
  'pf.nahratProfilni': 'Nahr\u00e1t profiln\u00ed foto',
  'pf.zrusitProfil': 'Zru\u0161it profil',
  'pf.nastaveniOznameni': 'Nastaven\u00ed ozn\u00e1men\u00ed',
  'pf.nastaveniOznameniPopis': 'Vyberte, pro kter\u00e9 ud\u00e1losti chcete dost\u00e1vat push ozn\u00e1men\u00ed.',
  'gal.overEmail': 'Pro nahr\u00e1v\u00e1n\u00ed fotografi\u00ed mus\u00edte nejprve ov\u011b\u0159it sv\u016fj e-mail.',
  'cesta.coMeCeka': 'Co m\u011b \u010dek\u00e1',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Zpr\u00e1vy',
  'zpr.hledatUzivatele': 'Hledat u\u017eivatele\u2026',
  'zpr.zadneKonverzace': 'Zat\u00edm \u017e\u00e1dn\u00e9 konverzace',
  'zpr.vyhledejteVyse': 'Vyhledejte u\u017eivatele v\u00fd\u0161e',
  'zpr.vyberteKonverzaci': 'Vyberte konverzaci nebo vyhledejte u\u017eivatele',
  'zpr.napisteZpravu': 'Napi\u0161te zpr\u00e1vu\u2026',
  'zpr.nahravam': 'Nahr\u00e1v\u00e1m\u2026',
  'zpr.prilozitObrazek': 'P\u0159ilo\u017eit obr\u00e1zek',
  'zpr.hlasovaZprava': 'Hlasov\u00e1 zpr\u00e1va',
  'zpr.zastavitNahravani': 'Zastavit nahr\u00e1v\u00e1n\u00ed',
  'zpr.obrazek': 'Obr\u00e1zek',
  'zpr.overteEmail': 'Pro odes\u00edl\u00e1n\u00ed zpr\u00e1v ov\u011b\u0159te sv\u016fj e-mail.',
  'zpr.profil': 'Profil',

  // šifrování
  'zpr.sifrovanaZprava': '\u0160ifrovan\u00e1 zpr\u00e1va',
  'zpr.odemkniNahore': '\u0160ifrovan\u00e1 zpr\u00e1va \u2014 odemkni si zpr\u00e1vy naho\u0159e.',
  'zpr.nelzeOtevrit': 'Tuhle \u0161ifrovanou zpr\u00e1vu se nepoda\u0159ilo otev\u0159\u00edt.',

  // hlášky
  'zpr.uzivatelNenalezen': 'U\u017eivatel nenalezen',
  'zpr.prijemceNenalezen': 'P\u0159\u00edjemce nenalezen',
  'zpr.prihlasteZnovu': 'P\u0159ihlaste se znovu (platnost tokenu vypr\u0161ela)',
  'zpr.serverNedostupny': 'Nelze se p\u0159ipojit k serveru. Zkontrolujte, zda b\u011b\u017e\u00ed backend.',
  'zpr.chybaOdeslani': 'Chyba p\u0159i odes\u00edl\u00e1n\u00ed',
  'zpr.souborVelky': 'Soubor je p\u0159\u00edli\u0161 velk\u00fd (max 5 MB)',
  'zpr.formatNepodporovan': 'Nepodporovan\u00fd form\u00e1t souboru',
  'zpr.mediaOdeslano': 'M\u00e9dia odesl\u00e1na',
  'zpr.mikrofon': 'Mikrofon nen\u00ed dostupn\u00fd',
  'zpr.hlasovkaOdeslana': 'Hlasov\u00e1 zpr\u00e1va odesl\u00e1na',
  'zpr.hlasovkaChyba': (p) => `Chyba p\u0159i odes\u00edl\u00e1n\u00ed hlasov\u00e9 zpr\u00e1vy: ${p.detail}`,
  'zpr.smazano': 'Konverzace smaz\u00e1na',
  'zpr.smazaniChyba': 'Nepoda\u0159ilo se smazat konverzaci',
  'zpr.smazaniPotvrzeni': 'Zmiz\u00ed ti ze seznamu v\u010detn\u011b p\u0159\u00edloh. Druh\u00e1 strana si svou kopii ponech\u00e1 \u2014 '
      + 'ze serveru se zpr\u00e1va \u00fapln\u011b sma\u017ee, a\u017e ji sma\u017eou oba.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Zadej pros\u00edm heslo.',
  'sif.zapnuto': '\u0160ifrov\u00e1n\u00ed je zapnut\u00e9.',
  'sif.odemceno': 'Zpr\u00e1vy jsou odem\u010den\u00e9.',
  'sif.hesloNesedi': 'Heslo nesed\u00ed.',
  'sif.prohlizecNeumi': 'Tenhle prohl\u00ed\u017ee\u010d neum\u00ed \u0161ifrov\u00e1n\u00ed, kter\u00e9 Bloom pou\u017e\u00edv\u00e1. Zpr\u00e1vy p\u016fjde ps\u00e1t, '
      + 'ale nebudou koncov\u011b \u0161ifrovan\u00e9.',
  'sif.noveJsouSifrovane': 'Nov\u00e9 zpr\u00e1vy jsou \u0161ifrovan\u00e9. Kl\u00ed\u010d m\u00e1\u0161 jen ty \u2014 server obsah nep\u0159e\u010dte.',
  'sif.odemkniZpravy': 'Odemkni si zpr\u00e1vy',
  'sif.odemkniPopis': 'Kl\u00ed\u010d se dr\u017e\u00ed jen v pam\u011bti t\u00e9hle z\u00e1lo\u017eky, tak\u017ee po obnoven\u00ed str\u00e1nky je pot\u0159eba heslo znovu. '
      + 'Ulo\u017eit ho nikam nem\u016f\u017eeme \u2014 pak by to nebylo \u0161ifrov\u00e1n\u00ed, kter\u00e9 m\u00e1\u0161 pod kontrolou jen ty.',
  'sif.zapniSifrovani': 'Zapni si \u0161ifrov\u00e1n\u00ed zpr\u00e1v',
  'sif.zapniPopis': 'Nov\u00e9 zpr\u00e1vy se za\u0161ifruj\u00ed p\u0159\u00edmo tady u tebe. Server dostane jen zm\u011b\u0165 znak\u016f '
      + 'a nep\u0159e\u010dte je \u2014 ani kdyby o n\u011b n\u011bkdo po\u017e\u00e1dal soudn\u011b.',
  'sif.pozorA': 'Pozor: kl\u00ed\u010d se odemyk\u00e1 tv\u00fdm heslem.',
  'sif.pozorTucne': 'Kdy\u017e ho zapomene\u0161, \u0161ifrovan\u00e9 zpr\u00e1vy nep\u0159e\u010dte nikdo',
  'sif.pozorB': ' \u2014 ani my. To je cel\u00fd smysl, ale znamen\u00e1 to, \u017ee heslo mus\u00ed\u0161 m\u00edt kde vz\u00edt.',
  'sif.mobilA': 'Zapnut\u00edm se zm\u011bn\u00ed i zp\u016fsob p\u0159ihla\u0161ov\u00e1n\u00ed: heslo u\u017e na server nebude chodit v\u016fbec, pos\u00edlat se bude jen jeho otisk.',
  'sif.mobilTucne': 'Star\u0161\u00ed mobiln\u00ed aplikace Bloom se pak k tomuhle \u00fa\u010dtu nep\u0159ihl\u00e1s\u00ed',
  'sif.mobilB': ', dokud ji neaktualizujeme. Na webu funguje v\u0161echno d\u00e1l.',
  'sif.zapnoutSifrovani': 'Zapnout \u0161ifrov\u00e1n\u00ed',
  'sif.odemknout': 'Odemknout',
  'sif.tvojeHeslo': 'Tvoje heslo do Bloomu',
  'sif.prilohaZamcena': '\u0160ifrovan\u00e1 p\u0159\u00edloha \u2014 odemkni si zpr\u00e1vy naho\u0159e.',
  'sif.prilohaChyba': 'P\u0159\u00edlohu se nepoda\u0159ilo otev\u0159\u00edt.',
  'sif.priloha': 'P\u0159\u00edloha zpr\u00e1vy',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Va\u0161e lokalita',
  'okoli.nastavtePolohu': 'Nastavte si polohu pro personalizovan\u00e9 v\u00fdsledky',
  'okoli.vyberteVyse': 'Vyberte lokalitu v\u00fd\u0161e, abyste vid\u011bli nab\u00eddky a odborn\u00edky ve sv\u00e9m okol\u00ed',
  'okoli.zadniOdbornici': 'V t\u00e9to lokalit\u011b zat\u00edm nejsou registrovan\u00ed odborn\u00edci',
  'okoli.zadneNabidky': 'V t\u00e9to lokalit\u011b zat\u00edm nejsou \u017e\u00e1dn\u00e9 nab\u00eddky',
  'okoli.zadniClenove': 'V t\u00e9to lokalit\u011b zat\u00edm nejsou \u017e\u00e1dn\u00ed \u010dlenov\u00e9 komunity',
  'okoli.vytvoritNabidku': 'Vytvo\u0159it nab\u00eddku',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Hled\u00e1m:',
  'hled.vysledkyPro': 'V\u00fdsledky hled\u00e1n\u00ed pro:',
  'hled.nicPro': 'Nic jsme nena\u0161li pro:',
  'hled.nicZkuste': 'Nic jsme nena\u0161li. Zkuste jin\u00e9 slovo.',
  'hled.zkratte': 'Zkuste zkr\u00e1tit hledan\u00fd v\u00fdraz nebo pou\u017e\u00edt jin\u00e9 kl\u00ed\u010dov\u00e9 slovo.',
  'hled.zadejte': 'Zadejte hledan\u00fd v\u00fdraz a stiskn\u011bte Enter',
  'hled.priklady': 'Nap\u0159.: FFS, hormony, jm\u00e9no, doktor, pr\u016fkaz, chirurgie\u2026',
  'hled.uzivatele': 'U\u017eivatel\u00e9',
  'hled.odbornici': 'Trans-friendly odborn\u00edci',
  'hled.clanky': 'Pr\u00e1vn\u00ed poradna \u2013 \u010cl\u00e1nky',
  'hled.otazky': 'Ot\u00e1zky komunity',
  'hled.nabidky': 'Nab\u00eddky pomoci',
  'hled.prispevky': 'P\u0159\u00edsp\u011bvky',
  'hled.recenze': 'Recenze odborn\u00edk\u016f',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'U\u017eivatel nenalezen',
  'up.oMne': 'O mn\u011b',
  'up.clenOd': '\u010clen/ka od',
  'up.odznakSpravce': 'Spr\u00e1vce',
  'up.odznakPravnik': 'Pr\u00e1vn\u00edk',
  'up.odznakOdbornik': 'Ov\u011b\u0159en\u00fd odborn\u00edk',
  'up.odznakPravnikOvereny': 'Ov\u011b\u0159en\u00fd pr\u00e1vn\u00edk',
  'up.odznakClen': 'Ov\u011b\u0159en\u00fd \u010dlen',
  'up.odznakPomocnik': 'Aktivn\u00ed pomocn\u00edk',
  'up.odznakDuveryhodny': 'D\u016fv\u011bryhodn\u00fd',

  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Zp\u011bt na Bloom',
  'kom.oProjektu': 'Bloom vznikl jako bezpe\u010dn\u00fd komunitn\u00ed prostor pro trans lidi v \u010cesk\u00e9 republice \u2013 m\u00edsto, '
      + 'kde lze sd\u00edlet zku\u0161enosti, naj\u00edt podporu, propojit se s odborn\u00edky a navazovat kontakty. '
      + 'Projekt provozuje komunita dobrovoln\u011b. C\u00edlem je diskr\u00e9tnost, soukrom\u00ed a vz\u00e1jemn\u00e1 pomoc.',
  'kom.kontaktText': 'M\u00e1te dotazy nebo pot\u0159ebujete pomoc? Nev\u00e1hejte n\u00e1s kontaktovat. Sna\u017e\u00edme se odpov\u00eddat co nejrychleji.',
  'kom.respekt': 'Respektujeme se navz\u00e1jem',
  'kom.respektPopis': 'Oslovujeme ka\u017ed\u00e9ho jeho preferovan\u00fdmi jm\u00e9ny a z\u00e1jmeny. Respektujeme r\u016fzn\u00e9 cesty a zku\u0161enosti '
      + '\u2013 nejsou \u017e\u00e1dn\u00e9 spr\u00e1vn\u00e9 nebo \u0161patn\u00e9 zp\u016fsoby, jak b\u00fdt trans.',
  'kom.soukromi': 'Chr\u00e1n\u00edme soukrom\u00ed ostatn\u00edch',
  'kom.soukromiPopis': 'Co se sd\u00edl\u00ed v Bloom, z\u016fst\u00e1v\u00e1 v Bloom. Nesd\u00edlejte informace o jin\u00fdch \u010dlenech komunity bez '
      + 'jejich souhlasu. Respektujeme anonymitu.',
  'kom.pomahame': 'Pom\u00e1h\u00e1me si',
  'kom.pomahamePopis': 'Bloom je o vz\u00e1jemn\u00e9 podpo\u0159e. Sd\u00edl\u00edme zku\u0161enosti, pom\u00e1h\u00e1me jeden druh\u00e9mu a vytv\u00e1\u0159\u00edme bezpe\u010dn\u00fd '
      + 'prostor pro v\u0161echny, kte\u0159\u00ed hledaj\u00ed spojen\u00ed nebo informace.',
  'kom.obtezovani': 'Netolerujeme obt\u011b\u017eov\u00e1n\u00ed',
  'kom.obtezovaniPopis': 'Jak\u00e9koli obt\u011b\u017eov\u00e1n\u00ed, \u0161ikana nebo nep\u0159\u00e1telsk\u00e9 koment\u00e1\u0159e nemaj\u00ed v Bloom m\u00edsto. Pokud se c\u00edt\u00edte '
      + 'nep\u0159\u00edjemn\u011b, kontaktujte administr\u00e1tora.',
  'kom.spam': '\u017d\u00e1dn\u00fd spam ani reklama',
  'kom.spamPopis': 'Bloom nen\u00ed obchodn\u00ed platforma. Nevkl\u00e1dejte nevy\u017e\u00e1danou reklamu ani komer\u010dn\u00ed obsah. '
      + 'Nab\u00eddky a popt\u00e1vky pat\u0159\u00ed do sekce Vz\u00e1jemn\u00e1 podpora.',
  'kom.prostor': 'Prostor pro v\u0161echny etapy',
  'kom.prostorPopis': 'Nejste sami, a\u0165 jste na jak\u00e9koli etap\u011b sv\u00e9 cesty. P\u0159ij\u00edm\u00e1me lidi p\u0159em\u00fd\u0161lej\u00edc\u00ed o tranzici, '
      + 'uprost\u0159ed n\u00ed i po n\u00ed \u2013 a ka\u017edou cestu p\u0159ij\u00edm\u00e1me takovou, jak\u00e1 je.',
  'kom.dataPopis': 'Bloom shroma\u017e\u010fuje pouze data nezbytn\u00e1 pro fungov\u00e1n\u00ed platformy: e-mail, p\u0159ezd\u00edvku a profil, '
      + 'kter\u00fd sami vytvo\u0159\u00edte.',
  'kom.dataTretiStrany': 'Va\u0161e data nejsou sd\u00edlena s t\u0159et\u00edmi stranami. Platforma nepou\u017e\u00edv\u00e1 sledovac\u00ed technologie ani reklamn\u00ed s\u00edt\u011b.',
  'kom.dataSmazani': 'M\u00e1te pr\u00e1vo po\u017e\u00e1dat o smaz\u00e1n\u00ed sv\u00e9ho \u00fa\u010dtu a v\u0161ech s n\u00edm spojen\u00fdch dat. Kontaktujte administr\u00e1tora.',

  'okoli.podtitulek': 'Najd\u011bte \u010dleny komunity, slu\u017eby a odborn\u00edky ve va\u0161em okol\u00ed',
  'okoli.cleneVOkoli': (p) => `\u010clenov\u00e9 komunity v okol\u00ed: ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Nab\u00eddky pomoci v okol\u00ed: ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Odborn\u00edci v okol\u00ed: ${p.misto}`,
  'hled.zobrazitVice': 'Zobrazit v\u00edce',
  'kom.titulek': 'Z\u00e1sady komunity',
  'kom.podtitulek': 'Bezpe\u010dn\u00fd prostor pro v\u0161echny',
  'kom.jakNahlasit': 'Jak nahl\u00e1sit probl\u00e9m?',
  'kom.jakNahlasitPopis': 'Pokud naraz\u00edte na nevhodn\u00e9 chov\u00e1n\u00ed, m\u00e1te dv\u011b mo\u017enosti: pou\u017eijte tla\u010d\u00edtko \u201eNahl\u00e1sit u\u017eivatele" '
      + 'na profilu, nebo napi\u0161te administr\u00e1torce.',
  'kom.duverne': 'Va\u0161e nahl\u00e1\u0161en\u00ed je d\u016fv\u011brn\u00e9.',
  'kom.ochranaSoukromi': 'Ochrana soukrom\u00ed',
  'obecne.zpetKratce': 'Zp\u011bt',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Zat\u00edm nikdo jin\u00fd v komunit\u011b nesd\u00edl\u00ed tuto f\u00e1zi ve\u0159ejn\u011b.',
  'cesta.poznamkaFazePriklad': 'Cokoliv, co chce\u0161 sd\u00edlet nebo si zapamatovat o t\u00e9to f\u00e1zi\u2026',
  'pruvodce.fazeNenalezena': 'F\u00e1ze nenalezena',
  'pruvodce.pripravujeme': 'Tuhle \u010d\u00e1st zat\u00edm p\u0159ipravujeme.',
  'pruvodce.krokyJenTy': 'Tvoje od\u0161krtnut\u00e9 kroky vid\u00ed\u0161 jen ty.',
  'pruvodce.nastavitFazi': 'Nastavit jako moji f\u00e1zi',
  'pruvodce.fazeNastavena': 'F\u00e1ze nastavena jako tvoje aktu\u00e1ln\u00ed',
  'pruvodce.chyba': 'Nepoda\u0159ilo se ulo\u017eit, zkus to pros\u00edm znovu',
  'pruvodce.kroku': 'krok\u016f',
  'pruvodce.odborniku': (p) => `${mnozne(p.pocet, 'odborn\u00edk', 'odborn\u00edci', 'odborn\u00edk\u016f')} pro tuhle f\u00e1zi`,
  'pruvodce.pribehu': (p) => `${mnozne(p.pocet, 'p\u0159\u00edb\u011bh', 'p\u0159\u00edb\u011bhy', 'p\u0159\u00edb\u011bh\u016f')} od lid\u00ed v t\u00e9hle f\u00e1zi`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Obnoven\u00ed hesla',
  'reset.popis': 'Zadejte nov\u00e9 heslo pro v\u00e1\u0161 \u00fa\u010det Bloom.',
  'reset.noveHeslo': 'Nov\u00e9 heslo',
  'reset.noveHesloPriklad': 'Zadejte nov\u00e9 heslo',
  'reset.potvrdit': 'Potvrdit nov\u00e9 heslo',
  'reset.nastavit': 'Nastavit nov\u00e9 heslo',
  'reset.ukladam': 'Ukl\u00e1d\u00e1n\u00ed\u2026',
  'reset.hotovo': 'Va\u0161e heslo bylo \u00fasp\u011b\u0161n\u011b zm\u011bn\u011bno. Nyn\u00ed se m\u016f\u017eete p\u0159ihl\u00e1sit.',
  'reset.neplatnyOdkaz': 'Neplatn\u00fd odkaz pro obnoven\u00ed hesla.',
  'reset.odkazVyprsel': 'Odkaz pro obnoven\u00ed hesla vypr\u0161el nebo je neplatn\u00fd. Po\u017e\u00e1dejte o nov\u00fd.',
  'reset.chyba': 'Nepoda\u0159ilo se obnovit heslo.',
  'reset.neshoda': 'Hesla se neshoduj\u00ed.',
  'reset.ztratiPristup': 'ztrat\u00ed p\u0159\u00edstup',

  'cesta.volitelne': 'Tato funkce je zcela voliteln\u00e1. Sd\u00edlej svou f\u00e1zi tranzice, pokud chce\u0161 \u2013 nebo si ji nech '
      + 'jen pro sebe. M\u016f\u017ee\u0161 tak\u00e9 naj\u00edt lidi v podobn\u00e9 \u017eivotn\u00ed f\u00e1zi.',
  'cesta.hledatVeFazi': 'Hledat lidi ve f\u00e1zi:',
  'cesta.jenVerejne': '(jen u\u017eivatel\u00e9, kte\u0159\u00ed sd\u00edl\u00ed ve\u0159ejn\u011b)',
  'pruvodce.zpetNaCestu': 'Zp\u011bt na Moji cestu',
  'pruvodce.tadyJsi': 'Tady jsi te\u010f',
  'reset.prejitNaPrihlaseni': 'P\u0159ej\u00edt na p\u0159ihl\u00e1\u0161en\u00ed',
  'reset.sifrovaniVarovani': 'M\u00e1\u0161-li zapnut\u00e9 \u0161ifrov\u00e1n\u00ed zpr\u00e1v: obnovou hesla se ke star\u00fdm \u0161ifrovan\u00fdm zpr\u00e1v\u00e1m u\u017e nedostane\u0161. '
      + 'Kl\u00ed\u010d k nim se odemyk\u00e1 p\u016fvodn\u00edm heslem a tady star\u00e9 heslo nikdo nezn\u00e1, tak\u017ee ho nejde p\u0159ebalit. '
      + 'Nov\u00e9 zpr\u00e1vy p\u016fjde \u0161ifrovat d\u00e1l, star\u00e9 u\u017e ne \u2014 ani my je nep\u0159e\u010dteme.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'P\u0159ihl\u00e1sit se',
  'uvod.vytvoritUcet': 'Vytvo\u0159it \u00fa\u010det',
  'uvod.uzMamUcet': 'U\u017e m\u00e1m \u00fa\u010det',
  'uvod.nadpis': 'Bezpe\u010dn\u00fd prostor pro trans komunitu',
  'uvod.podnadpis': 'Bloom je soukrom\u00e9 m\u00edsto, kde m\u016f\u017ee\u0161 mluvit otev\u0159en\u011b, naj\u00edt trans-friendly odborn\u00edky '
      + 'a proj\u00edt si tranzici mezi lidmi, kte\u0159\u00ed v\u011bd\u00ed, o \u010dem to je.',
  'uvod.zdarma': 'Registrace je zdarma. Obsah Bloomu se otev\u0159e a\u017e po p\u0159ihl\u00e1\u0161en\u00ed.',
  'uvod.kCemuJe': 'K \u010demu Bloom je',
  'uvod.kCemuJe1': 'Hledat v \u010cesku informace o tranzici znamen\u00e1 v\u011bt\u0161inou proklikat se roztrou\u0161en\u00fdmi diskuzemi, '
      + 'zastaral\u00fdmi \u010dl\u00e1nky a odkazy, u kter\u00fdch \u010dlov\u011bk nev\u00ed, komu m\u016f\u017ee v\u011b\u0159it. A na spoustu ot\u00e1zek '
      + 'stejn\u011b nejl\u00edp odpov\u00ed n\u011bkdo, kdo si t\u00edm s\u00e1m pro\u0161el.',
  'uvod.kCemuJe2': 'Bloom d\u00e1v\u00e1 tohle v\u0161echno na jedno m\u00edsto: ov\u011b\u0159en\u00e9 odborn\u00edky, se kter\u00fdmi m\u00e1 komunita dobrou '
      + 'zku\u0161enost, pr\u016fvodce jednotliv\u00fdmi f\u00e1zemi tranzice, pr\u00e1vn\u00ed poradnu a hlavn\u011b lidi, kter\u00fdm se d\u00e1 napsat.',
  'uvod.kCemuJe3': 'A proto\u017ee jde o v\u011bci, kter\u00e9 o sob\u011b \u010dlov\u011bk nechce vykl\u00e1dat cel\u00e9mu internetu, je Bloom '
      + 'od za\u010d\u00e1tku stav\u011bn\u00fd tak, aby zvenč\u00ed nebylo vid\u011bt v\u016fbec nic.',
  'uvod.coNajdes': 'Co v Bloomu najde\u0161',
  'uvod.coNajdesPopis': 'Osm \u010d\u00e1st\u00ed, kter\u00e9 na sebe navazuj\u00ed \u2014 od praktick\u00e9 pomoci po sd\u00edlen\u00e9 zku\u0161enosti.',
  'uvod.soukromiZaklad': 'Soukrom\u00ed nen\u00ed dopln\u011bk, ale z\u00e1klad',
  'uvod.jakZabezpeceny': 'Jak je Bloom zabezpe\u010den\u00fd',
  'uvod.zabezpeceniPopis': 'Data \u010dlen\u016f se nikde neprod\u00e1vaj\u00ed ani neanalyzuj\u00ed. V Bloomu neb\u011b\u017e\u00ed \u017e\u00e1dn\u00e9 reklamn\u00ed ani '
      + 'analytick\u00e9 sledov\u00e1n\u00ed \u2014 \u017e\u00e1dn\u00fd ciz\u00ed skript se o tob\u011b nedozv\u00ed nic.',
  'uvod.coNeumi': 'Co Bloom naopak neum\u00ed',
  'uvod.metadataTucne': 'kdo komu a kdy napsal',
  'uvod.coNeumiA': 'Server v\u017edycky v\u00ed,',
  'uvod.coNeumiB': ' \u2014 bez toho by zpr\u00e1vu nedoru\u010dil. Tahle metadata neskryje ani koncov\u00e9 \u0161ifrov\u00e1n\u00ed a neum\u00ed to '
      + 'ani Signal. Profily se \u0161ifrovat nedaj\u00ed, proto\u017ee je server mus\u00ed uk\u00e1zat ostatn\u00edm. A proto\u017ee je Bloom '
      + 'webov\u00e1 aplikace, st\u00e1hne si \u0161ifrovac\u00ed k\u00f3d z na\u0161eho serveru p\u0159i ka\u017ed\u00e9m otev\u0159en\u00ed \u2014 kdo by ovl\u00e1dl '
      + 'server, mohl by teoreticky podstr\u010dit upraven\u00fd. Proti tomu pom\u016f\u017ee jen podepsan\u00e1 aplikace z obchodu.',
  'uvod.pridejSe': 'P\u0159idej se',
  'uvod.pridejSePopis': 'Sta\u010d\u00ed p\u0159ezd\u00edvka a e-mail \u2014 vlastn\u00ed jm\u00e9no nikde uv\u00e1d\u011bt nemus\u00ed\u0161. Co o sob\u011b nap\u00ed\u0161e\u0161, '
      + 'z\u016fst\u00e1v\u00e1 na tob\u011b a kdykoli to m\u016f\u017ee\u0161 zm\u011bnit nebo smazat.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Nabídni pomoc nebo o ni po\u017e\u00e1dej \u2014 od doprovodu k l\u00e9ka\u0159i p\u0159es p\u016fj\u010den\u00ed oble\u010den\u00ed a\u017e po '
      + '\u201epot\u0159ebuju si s n\u011bk\u00fdm promluvit".',
  'uvod.karta.odbornici': 'Sexuologov\u00e9, endokrinologov\u00e9, chirurgov\u00e9, psychoterapeutky i kade\u0159nictv\u00ed. S mapou, kontakty a zku\u0161enostmi ostatn\u00edch.',
  'uvod.karta.pravo': 'Zm\u011bna jm\u00e9na, \u00fa\u0159edn\u00ed doklady, pr\u00e1ce, \u0161kola. Odpov\u00eddaj\u00ed lid\u00e9, kte\u0159\u00ed se v tom vyznaj\u00ed.',
  'uvod.karta.pruvodce': 'Co t\u011b \u010dek\u00e1 v jednotliv\u00fdch kroc\u00edch \u2014 od prvn\u00edch ot\u00e1zek po operace. S odkazy na ov\u011b\u0159en\u00e9 zdroje a odborn\u00edky.',
  'uvod.karta.zpravy': 'Napi\u0161 komukoli z komunity. Zpr\u00e1vy i p\u0159\u00edlohy jsou na serveru ulo\u017een\u00e9 za\u0161ifrovan\u00e9.',
  'uvod.karta.zkusenosti': 'Skute\u010dn\u00e9 p\u0159\u00edb\u011bhy od lid\u00ed, kte\u0159\u00ed si t\u00edm pro\u0161li. Bez cenzury a bez p\u0159ikr\u00e1\u0161lov\u00e1n\u00ed.',
  'uvod.karta.aktuality': 'Co se d\u011bje kolem trans t\u00e9mat v \u010cesku \u2014 zm\u011bny z\u00e1kon\u016f, akce, novinky z komunity.',
  'uvod.karta.okoli': 'Kdo je pobl\u00ed\u017e tebe. A\u0165 v\u00ed\u0161, \u017ee v tom nejsi sama ani v men\u0161\u00edm m\u011bst\u011b.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Zvenč\u00ed nen\u00ed vid\u011bt v\u016fbec nic',
  'uvod.bezp.zvencinicText': 'Profily, p\u0159\u00edb\u011bhy, fotky, nab\u00eddky i obr\u00e1zky u p\u0159\u00edsp\u011bvk\u016f vy\u017eaduj\u00ed p\u0159ihl\u00e1\u0161en\u00ed. Bez \u00fa\u010dtu server '
      + 'nevyd\u00e1 \u017e\u00e1dn\u00fd \u00fadaj o \u010dlenech \u2014 ani vyhled\u00e1va\u010d\u016fm.',
  'uvod.bezp.hesla': 'Hesla nezn\u00e1 nikdo',
  'uvod.bezp.heslaText': 'Ukl\u00e1d\u00e1 se jen bcrypt otisk, ze kter\u00e9ho se p\u016fvodn\u00ed heslo spo\u010d\u00edtat ned\u00e1. Ani spr\u00e1vkyn\u011b tvoje heslo '
      + 'nevid\u00ed a nem\u016f\u017ee ti ho poslat \u2014 jen ti umo\u017en\u00ed nastavit nov\u00e9.',
  'uvod.bezp.sifrovani': 'Zpr\u00e1vy \u0161ifrovan\u00e9 od tebe k n\u00ed',
  'uvod.bezp.sifrovaniText': 'Kdy\u017e si zapne\u0161 koncov\u00e9 \u0161ifrov\u00e1n\u00ed, text i p\u0159\u00edlohy se za\u0161ifruj\u00ed p\u0159\u00edmo u tebe v prohl\u00ed\u017ee\u010di. Kl\u00ed\u010d se '
      + 'odemyk\u00e1 tv\u00fdm heslem a nikdy neopust\u00ed tvoje za\u0159\u00edzen\u00ed \u2014 server dostane jen zm\u011b\u0165 znak\u016f a nep\u0159e\u010dte ji, '
      + 'ani kdyby o ni n\u011bkdo po\u017e\u00e1dal soudn\u011b. Bez \u0161ifrov\u00e1n\u00ed jsou zpr\u00e1vy aspo\u0148 za\u0161ifrovan\u00e9 na disku serveru.',
  'uvod.bezp.kontakty': 'Kontakty z\u016fst\u00e1vaj\u00ed u tebe',
  'uvod.bezp.kontaktyText': 'E-mail ani telefon se ostatn\u00edm \u010dlen\u016fm z aplikace nikdy nevrac\u00ed. F\u00e1ze tranzice je soukrom\u00e1, dokud ji '
      + 'sama nezve\u0159ejn\u00ed\u0161 \u2014 a od\u0161krtnut\u00e9 kroky v Pr\u016fvodci vid\u00ed\u0161 jen ty.',
  'uvod.bezp.smazane': 'Smazan\u00e9 je opravdu smazan\u00e9',
  'uvod.bezp.smazaneText': 'Konverzaci m\u016f\u017ee\u0161 kdykoli smazat. Kdy\u017e ji sma\u017eou ob\u011b strany, zmiz\u00ed ze serveru natrvalo i s p\u0159\u00edlohami.',
  'uvod.bezp.server': 'Vlastn\u00ed server v Evrop\u011b',
  'uvod.bezp.serverText': 'Bloom b\u011b\u017e\u00ed na vlastn\u00edm serveru v Evropsk\u00e9 unii, v\u00fdhradn\u011b p\u0159es HTTPS. Datab\u00e1ze nen\u00ed z internetu '
      + 'dostupn\u00e1. Z\u00e1lohy odch\u00e1zej\u00ed za\u0161ifrovan\u00e9 na jin\u00e9 \u00falo\u017ei\u0161t\u011b a jejich obnova je vyzkou\u0161en\u00e1.',

  'uvod.karta.pruvodceNazev': 'Průvodce fází tranzice',
  'uvod.karta.zpravyNazev': 'Soukromé zprávy',

  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Nab\u00eddn\u011bte sv\u00e9 dovednosti a z\u00edskejte pomoc od ostatn\u00edch \u010dlen\u016f komunity',
  'pod.vse': 'V\u0161e',
  'pod.nabidky': 'Nab\u00eddky',
  'pod.poptavky': 'Popt\u00e1vky',
  'pod.nabidka': 'Nab\u00eddka',
  'pod.poptavka': 'Popt\u00e1vka',
  'pod.celaCR': 'Cel\u00e1 \u010cR',
  'pod.celySvet': 'Cel\u00fd sv\u011bt',
  'pod.cesko': '\u010cesk\u00e1 republika',
  'pod.svet': 'Sv\u011bt',
  'pod.vsechnyTypy': 'V\u0161echny typy',
  'pod.moje': (p) => `Moje (${p.pocet})`,
  'pod.pridat': 'P\u0159idat',
  'pod.overEmail': 'Pro p\u0159id\u00e1n\u00ed nab\u00eddky ov\u011b\u0159te sv\u016fj e-mail',
  'pod.novaPoptavka': 'Nov\u00e1 popt\u00e1vka',
  'pod.novaNabidka': 'Nov\u00e1 nab\u00eddka',
  'pod.popisPoptavky': 'Napi\u0161te, co hled\u00e1te a co nab\u00edz\u00edte v\u00fdm\u011bnou.',
  'pod.popisNabidky': 'Nab\u00eddn\u011bte sv\u00e9 dovednosti ostatn\u00edm \u010dlen\u016fm komunity.',
  'pod.typPrispevku': 'Typ p\u0159\u00edsp\u011bvku',
  'pod.volitelne': '(voliteln\u00e9)',
  'pod.coNabizim': 'Co nab\u00edz\u00edm',
  'pod.coNabizimP': 'Co nab\u00edz\u00edm *',
  'pod.coHledamP': 'Co hled\u00e1m *',
  'pod.coHledamVymenou': 'Co hled\u00e1m v\u00fdm\u011bnou',
  'pod.priklOffer': 'nap\u0159. va\u0159en\u00ed, \u00fa\u010desy, p\u0159eklad\u2026',
  'pod.priklNeed': 'nap\u0159. mas\u00e1\u017ee, fotografie\u2026',
  'pod.poptavkaSeZobrazi': 'Va\u0161e popt\u00e1vka se zobraz\u00ed v sekci Popt\u00e1vky.',
  'pod.nabidkaSeZobrazi': 'Pokud vypln\u00edte, va\u0161e nab\u00eddka se zobraz\u00ed tak\u00e9 v sekci Popt\u00e1vky.',
  'pod.popis': 'Popis',
  'pod.popisPriklad': 'Podrobn\u011bj\u0161\u00ed popis\u2026',
  'pod.oblast': 'Oblast',
  'pod.lokalita': 'Lokalita',
  'pod.nechciUvadet': 'Nechci uv\u00e1d\u011bt',
  'pod.kategorie': 'Kategorie',
  'pod.ostatni': 'Ostatn\u00ed',
  'pod.pridatPoptavku': 'P\u0159idat popt\u00e1vku',
  'pod.pridatNabidku': 'P\u0159idat nab\u00eddku',
  'pod.odpovedetNaPrispevek': 'Odpov\u011bd\u011bt na p\u0159\u00edsp\u011bvek',
  'pod.napisteAutorovi': 'Napi\u0161te autorovi p\u0159\u00edsp\u011bvku soukromou zpr\u00e1vu.',
  'pod.od': (p) => `Od: ${p.kdo}`,
  'pod.odeslatZpravu': 'Odeslat zpr\u00e1vu',
  'pod.konceptOdpovedi': (p) => `Dobr\u00fd den! Zaujala m\u011b va\u0161e ${p.co} \u201e${p.nazev}". `,
  'pod.konceptPoptavka': 'popt\u00e1vka',
  'pod.konceptNabidka': 'nab\u00eddka',
  'pod.zadneMoje': 'Nem\u00e1te \u017e\u00e1dn\u00e9 p\u0159\u00edsp\u011bvky',
  'pod.zadneNalezeny': '\u017d\u00e1dn\u00e9 p\u0159\u00edsp\u011bvky nenalezeny',
  'pod.vytvortePrvni': 'Vytvo\u0159te svou prvn\u00ed nab\u00eddku nebo popt\u00e1vku',
  'pod.zkusteFiltry': 'Zkuste zm\u011bnit filtry nebo p\u0159idejte nov\u00fd p\u0159\u00edsp\u011bvek',
  'pod.expirovano': 'Expirov\u00e1no',
  'pod.hledam': 'Hled\u00e1m',
  'pod.hledamCo': (p) => `Hled\u00e1m: ${p.co}`,
  'pod.nabizimCo': (p) => `Nab\u00edz\u00edm: ${p.co}`,
  'pod.expirovala': 'Tato nab\u00eddka expirovala. Kontaktujte administr\u00e1tora pro obnoven\u00ed.',
  'pod.odpovedet': 'Odpov\u011bd\u011bt',
  'pod.upravitPrispevek': 'Upravit p\u0159\u00edsp\u011bvek',
  'pod.upravtePrispevek': 'Upravte svou nab\u00eddku nebo popt\u00e1vku.',
  'pod.nabizimP': 'Nab\u00edz\u00edm *',
  'pod.hledamPotrebuji': 'Hled\u00e1m / pot\u0159ebuji',
  'pod.coNabizitePriklad': 'Co nab\u00edz\u00edte\u2026',
  'pod.coHledatePriklad': 'Co hled\u00e1te\u2026',
  'pod.ulozitZmeny': 'Ulo\u017eit zm\u011bny',
  'pod.vytvorenoPoptavka': 'Popt\u00e1vka vytvo\u0159ena!',
  'pod.vytvorenoNabidka': 'Nab\u00eddka vytvo\u0159ena!',
  'pod.chybaVytvorit': 'Nepoda\u0159ilo se vytvo\u0159it p\u0159\u00edsp\u011bvek',
  'pod.opravduSmazat': 'Opravdu chcete smazat tuto nab\u00eddku?',
  'pod.smazano': 'Smaz\u00e1no',
  'pod.chybaSmazat': 'Nepoda\u0159ilo se smazat',
  'pod.aktualizovano': 'P\u0159\u00edsp\u011bvek aktualizov\u00e1n!',
  'pod.chybaUlozit': 'Nepoda\u0159ilo se ulo\u017eit',
  'pod.zpravaOdeslana': 'Zpr\u00e1va odesl\u00e1na!',
  'pod.chybaOdeslat': 'Nepoda\u0159ilo se odeslat zpr\u00e1vu',
  'obecne.hledatPriklad': 'Hledat\u2026',
  'obecne.upravit': 'Upravit',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Najd\u011bte ov\u011b\u0159en\u00e9 odborn\u00edky, kte\u0159\u00ed v\u00e1m pomohou na va\u0161\u00ed cest\u011b',
  'odb.hledatPriklad': 'Hledat podle jm\u00e9na nebo m\u011bsta\u2026',
  'odb.vsechnyObory': 'V\u0161echny obory',
  'odb.radit': '\u0158adit:',
  'odb.vychozi': 'V\u00fdchoz\u00ed',
  'odb.nejvyssiHodnoceni': '\u2605 Nejvy\u0161\u0161\u00ed hodnocen\u00ed',
  'odb.nejnizsiHodnoceni': '\u2605 Nejni\u017e\u0161\u00ed hodnocen\u00ed',
  'odb.zadniNalezeni': '\u017d\u00e1dn\u00ed odborn\u00edci nenalezeni',
  'odb.zkusteFiltry': 'Zkuste zm\u011bnit filtry',
  'odb.recenzi': (p) => mnozne(p.pocet, 'recenze', 'recenze', 'recenz\u00ed'),
  'odb.dostupnyV': 'Dostupn\u00fd v lokalit\u00e1ch:',
  'odb.otevritVMapach': 'Otev\u0159\u00edt v map\u00e1ch',
  'odb.pridatRecenzi': 'P\u0159idat recenzi',
  'odb.ohodnotte': 'Ohodno\u0165te svou zku\u0161enost s t\u00edmto odborn\u00edkem.',
  'odb.vaseHodnoceni': 'Va\u0161e hodnocen\u00ed *',
  'odb.popisZkusenosti': 'Popis zku\u0161enosti',
  'odb.popisteZkusenost': 'Popi\u0161te va\u0161i zku\u0161enost\u2026',
  'odb.odeslatRecenzi': 'Odeslat recenzi',
  'odb.recenze': (p) => `Recenze (${p.pocet})`,
  'odb.zadneRecenze': 'Zat\u00edm \u017e\u00e1dn\u00e9 recenze. Bu\u010fte prvn\u00ed!',
  'odb.vyberteOdbornika': 'Vyberte odborn\u00edka pro zobrazen\u00ed detailu a mapy',
  'odb.pridatOdbornika': 'P\u0159idat odborn\u00edka',
  'odb.pridejteOdbornika': 'P\u0159idejte nov\u00e9ho ov\u011b\u0159en\u00e9ho odborn\u00edka do seznamu.',
  'odb.navrhnout': 'Navrhnout odborn\u00edka',
  'odb.navrhnetePopis': 'Navrhn\u011bte odborn\u00edka ke schv\u00e1len\u00ed administr\u00e1tory.',
  'odb.navrhVysvetleni': 'V\u00e1\u0161 n\u00e1vrh bude odesl\u00e1n ke schv\u00e1len\u00ed administr\u00e1torům. Po schv\u00e1len\u00ed se zobraz\u00ed v seznamu.',
  'odb.overEmail': 'Pro n\u00e1vrh odborn\u00edka ov\u011b\u0159te sv\u016fj e-mail',
  'odb.jmeno': 'Jm\u00e9no *',
  'odb.kategorie': 'Kategorie *',
  'odb.popis': 'Popis',
  'odb.popisPriklad': 'Specializace, zku\u0161enosti\u2026',
  'odb.adresa': 'Adresa *',
  'odb.mesto': 'M\u011bsto *',
  'odb.kraj': 'Kraj',
  'odb.vyber': 'Vyber',
  'odb.stat': 'St\u00e1t',
  'odb.cesko': '\u010cesko',
  'odb.telefon': 'Telefon',
  'odb.web': 'Web',
  'odb.odesilam': 'Odes\u00edl\u00e1m\u2026',
  'odb.odeslatKeSchvaleni': 'Odeslat ke schv\u00e1len\u00ed',
  'odb.recenzePridana': 'Recenze p\u0159id\u00e1na!',
  'odb.chybaRecenze': 'Nepoda\u0159ilo se p\u0159idat recenzi',
  'odb.odeslanKeSchvaleni': 'Odborn\u00edk odesl\u00e1n ke schv\u00e1len\u00ed!',
  'odb.chybaOdeslat': 'Nepoda\u0159ilo se odeslat odborn\u00edka',
  'odb.pridan': 'Odborn\u00edk p\u0159id\u00e1n!',
  'odb.chybaPridat': 'Nepoda\u0159ilo se p\u0159idat',
  'odb.polozitOtazku': 'Polo\u017eit ot\u00e1zku',
  'odb.novaOtazka': 'Nov\u00e1 ot\u00e1zka pro odborn\u00edky',
  'odb.naCoSeZeptat': 'Na co se chcete zeptat odborn\u00edk\u016f?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informace a podpora pro trans komunitu',
  'prav.zpetNaPoradnu': 'Zp\u011bt na Pr\u00e1vn\u00ed poradnu',
  'prav.clankyAPruvodci': '\u010cl\u00e1nky a pr\u016fvodci',
  'prav.pridatClanek': 'P\u0159idat \u010dl\u00e1nek',
  'prav.novyClanek': 'Nov\u00fd \u010dl\u00e1nek',
  'prav.vytvorteClanek': 'Vytvo\u0159te nov\u00fd \u010dl\u00e1nek do pr\u00e1vn\u00ed poradny.',
  'prav.nazev': 'N\u00e1zev *',
  'prav.kategorie': 'Kategorie',
  'prav.publikovatIhned': 'Publikovat ihned',
  'prav.publikovano': 'Publikov\u00e1no',
  'prav.obsah': 'Obsah *',
  'prav.obsahPriklad': 'Obsah \u010dl\u00e1nku\u2026',
  'prav.zadneClanky': '\u017d\u00e1dn\u00e9 \u010dl\u00e1nky v t\u00e9to kategorii',
  'prav.skryto': 'Skryto',
  'prav.skryt': 'Skr\u00fdt',
  'prav.publikovat': 'Publikovat',
  'prav.upravitClanek': 'Upravit \u010dl\u00e1nek',
  'prav.upravteObsah': 'Upravte obsah tohoto \u010dl\u00e1nku.',
  'prav.clanekPridan': '\u010cl\u00e1nek p\u0159id\u00e1n!',
  'prav.chybaPridat': 'Nepoda\u0159ilo se p\u0159idat \u010dl\u00e1nek',
  'prav.clanekUpraven': '\u010cl\u00e1nek upraven!',
  'prav.opravduSmazat': 'Opravdu smazat tento \u010dl\u00e1nek?',
  'prav.chybaStav': 'Nepoda\u0159ilo se zm\u011bnit stav',
  'prav.pridatOtazku': 'P\u0159idat ot\u00e1zku',
  'prav.novaOtazka': 'Nov\u00e1 ot\u00e1zka',
  'prav.naCoSeZeptat': 'Na co se chcete zeptat?',
  'obecne.vse': 'V\u0161e',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Novinky ze sv\u011bta trans komunity',
  'akt.prehratVideo': 'P\u0159ehr\u00e1t video',
  'akt.obrazekVClanku': 'Obr\u00e1zek v \u010dl\u00e1nku',
  'akt.clanekNenalezen': '\u010cl\u00e1nek nenalezen',
  'akt.zpetNaAktuality': 'Zp\u011bt na aktuality',
  'akt.autor': (p) => `Autor: ${p.kdo}`,
  'akt.osobniPribeh': 'Osobn\u00ed p\u0159\u00edb\u011bh',
  'akt.upravitClanek': 'Upravit \u010dl\u00e1nek',
  'akt.komentare': (p) => `Koment\u00e1\u0159e (${p.pocet})`,
  'akt.zadneKomentare': 'Zat\u00edm \u017e\u00e1dn\u00e9 koment\u00e1\u0159e. Bu\u010fte prvn\u00ed!',
  'akt.pridatKomentar': 'P\u0159idat koment\u00e1\u0159\u2026',
  'akt.proKomentovaniOverte': 'Pro komentov\u00e1n\u00ed ov\u011b\u0159te sv\u016fj e-mail.',
  'akt.profil': 'Profil',
  'akt.prihlasteSeProKomentovani': 'P\u0159ihlaste se pro komentov\u00e1n\u00ed.',
  'akt.upravteObsah': 'Upravte obsah tohoto \u010dl\u00e1nku.',
  'akt.nadpisP': 'Nadpis *',
  'akt.nadpis': 'Nadpis',
  'akt.obsahP': 'Obsah *',
  'akt.textClanku': 'Text \u010dl\u00e1nku\u2026',
  'akt.obrazekUrlNeboSoubor': 'Obr\u00e1zek (URL nebo soubor)',
  'akt.videoUrlNeboSoubor': 'Video (URL nebo soubor)',
  'akt.ukladam': 'Ukl\u00e1d\u00e1m\u2026',
  'akt.novaAktualita': 'Nov\u00e1 aktualita',
  'akt.sdiletPribeh': 'Sd\u00edlet p\u0159\u00edb\u011bh',
  'akt.vytvoritAktualitu': 'Vytvo\u0159it aktualitu',
  'akt.sdiletZkusenost': 'Sd\u00edlet zku\u0161enost',
  'akt.napisteAktualitu': 'Napi\u0161te novou aktualitu pro komunitu.',
  'akt.podelteSe': 'Pod\u011blte se o svou zku\u0161enost s komunitou.',
  'akt.obrazek': 'Obr\u00e1zek',
  'akt.nahratObrazek': 'Nahr\u00e1t obr\u00e1zek\u2026',
  'akt.nahratVideo': 'Nahr\u00e1t video\u2026',
  'akt.neboUrl': 'nebo URL:',
  'akt.textAktuality': 'Text aktuality\u2026',
  'akt.sdilejtePribeh': 'Sd\u00edlejte sv\u016fj p\u0159\u00edb\u011bh nebo zku\u0161enost s komunitou\u2026',
  'akt.nahravam': 'Nahr\u00e1v\u00e1m\u2026',
  'akt.publikovat': 'Publikovat',
  'akt.zkusenostiTucne': 'Osobn\u00ed zku\u0161enosti \u010dlen\u016f komunity.',
  'akt.zkusenostiPopis': 'Tato sekce slou\u017e\u00ed ke sd\u00edlen\u00ed \u017eivotn\u00edch zku\u0161enost\u00ed a p\u0159\u00edb\u011bh\u016f. P\u0159\u00edsp\u011bvky mohou obsahovat text, obr\u00e1zky nebo videa.',
  'akt.sdiletSvujPribeh': 'Sd\u00edlet sv\u016fj p\u0159\u00edb\u011bh',
  'akt.zadneAktuality': '\u017d\u00e1dn\u00e9 aktuality',
  'akt.zadneVKategorii': 'V t\u00e9to kategorii zat\u00edm nejsou \u017e\u00e1dn\u00e9 aktuality',
  'akt.publikovan': 'P\u0159\u00edsp\u011bvek publikov\u00e1n!',
  'akt.chybaPublikovat': 'Nepoda\u0159ilo se publikovat',
  'akt.opravduSmazat': 'Opravdu chcete smazat tento p\u0159\u00edsp\u011bvek?',
  'akt.chyba': 'Chyba',
  'akt.chybaKomentar': 'Nepoda\u0159ilo se p\u0159idat koment\u00e1\u0159',
  'akt.chybaSmazatKomentar': 'Nepoda\u0159ilo se smazat koment\u00e1\u0159',
  'akt.aktualizovan': 'P\u0159\u00edsp\u011bvek aktualizov\u00e1n!',
  'obecne.smazat': 'Smazat',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Uva\u017euji o tranzici',
  'faze.thinking.popis': 'P\u0159em\u00fd\u0161l\u00edm, kdo jsem a jak\u00e1 cesta je ta moje.',
  'faze.research': 'Hled\u00e1m informace',
  'faze.research.popis': '\u010ctu, pt\u00e1m se, hled\u00e1m zdroje a komunitu.',
  'faze.therapist': 'Prvn\u00ed n\u00e1v\u0161t\u011bva terapeuta',
  'faze.therapist.popis': 'Mluv\u00edm s odborn\u00edkem o sv\u00e9 cest\u011b.',
  'faze.hormones': 'Hormon\u00e1ln\u00ed l\u00e9\u010dba',
  'faze.hormones.popis': 'Za\u010d\u00edn\u00e1m nebo pokra\u010duji v hormon\u00e1ln\u00ed terapii.',
  'faze.documents': 'Zm\u011bna doklad\u016f',
  'faze.documents.popis': 'Pracuji na \u00fa\u0159edn\u00ed zm\u011bn\u011b jm\u00e9na nebo pohlav\u00ed.',
  'faze.cosmetic': 'Kosmetick\u00e9 \u00fapravy',
  'faze.cosmetic.popis': 'Pracuji na sv\u00e9m vzhledu \u2013 vlasy, make-up, styl.',
  'faze.surgery-thinking': 'Zva\u017euji operace',
  'faze.surgery-thinking.popis': 'P\u0159em\u00fd\u0161l\u00edm o chirurgick\u00fdch mo\u017enostech.',
  'faze.surgery': 'Po operac\u00edch',
  'faze.surgery.popis': 'Jsem po jedn\u00e9 nebo v\u00edce operac\u00edch.',
  'faze.stable': 'Stabiln\u00ed f\u00e1ze',
  'faze.stable.popis': 'Jsem na m\u00edst\u011b, kde chci b\u00fdt, a \u017eiji sv\u016fj \u017eivot.',
  'faze.individual': 'Individu\u00e1ln\u00ed cesta',
  'faze.individual.popis': 'Moje cesta neodpov\u00edd\u00e1 \u017e\u00e1dn\u00e9 \u0161katulce \u2013 a to je OK.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Tady se sd\u00edl\u00ed p\u0159\u00edb\u011bhy.',
  'zk.pribehNenalezen': 'P\u0159\u00edb\u011bh nenalezen',
  'zk.zpetNaPribehy': 'Zp\u011bt na p\u0159\u00edb\u011bhy',
  'zk.komunita': 'Komunita',
  'zk.pribeh': 'P\u0159\u00edb\u011bh',
  'zk.upravitPribeh': 'Upravit p\u0159\u00edb\u011bh',
  'zk.upravtePribeh': 'Upravte sv\u016fj sd\u00edlen\u00fd p\u0159\u00edb\u011bh.',
  'zk.textPribehu': 'Text p\u0159\u00edb\u011bhu\u2026',
  'zk.fazeTranzice': 'F\u00e1ze tranzice',
  'zk.neuvadet': 'Neuv\u00e1d\u011bt',
  'zk.ukazeSeLidem': 'P\u0159\u00edb\u011bh se uk\u00e1\u017ee lidem, kte\u0159\u00ed si \u010dtou pr\u016fvodce touto f\u00e1z\u00ed.',
  'zk.sdiletPribeh': 'Sd\u00edlet p\u0159\u00edb\u011bh',
  'zk.overEmail': 'Pro sd\u00edlen\u00ed p\u0159\u00edb\u011bhu ov\u011b\u0159te sv\u016fj e-mail',
  'zk.zadnePribehy': 'Zat\u00edm \u017e\u00e1dn\u00e9 p\u0159\u00edb\u011bhy. Bu\u010fte prvn\u00ed!',
  'zk.nazevPribehu': 'N\u00e1zev va\u0161eho p\u0159\u00edb\u011bhu\u2026',
  'zk.pribehP': 'P\u0159\u00edb\u011bh *',
  'zk.sdilejteZkusenost': 'Sd\u00edlejte svou zku\u0161enost s komunitou\u2026',
  'zk.chybaNacist': 'Nepoda\u0159ilo se na\u010d\u00edst p\u0159\u00edb\u011bhy',
  'zk.vyplnteNadpis': 'Vypl\u0148te nadpis a obsah',
  'zk.spatnyOdkaz': 'Odkaz na obr\u00e1zek mus\u00ed za\u010d\u00ednat http://, https:// nebo /',
  'zk.sdilen': 'P\u0159\u00edb\u011bh sd\u00edlen!',
  'zk.chybaSdilet': 'Nepoda\u0159ilo se sd\u00edlet',
  'zk.opravduSmazat': 'Opravdu smazat tento p\u0159\u00edb\u011bh?',
  'zk.smazan': 'P\u0159\u00edb\u011bh smaz\u00e1n',
  'zk.aktualizovan': 'P\u0159\u00edb\u011bh aktualizov\u00e1n!',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'V\u00e1\u0161 e-mail nen\u00ed ov\u011b\u0159en. Pros\u00edm potvr\u010fte e-mail.',
  'ram.odesilam': 'Odes\u00edl\u00e1m\u2026',
  'ram.znovuOdeslat': 'Znovu odeslat',
  'ram.chceteUpozorneni': 'Chcete dost\u00e1vat upozorn\u011bn\u00ed na nov\u00e9 zpr\u00e1vy?',
  'ram.tedNe': 'Te\u010f ne',
  'ram.paticka': '\u00a9 2026 Bloom \u2013 soukrom\u00fd prostor pro trans komunitu',
  'ram.zasadyKomunity': 'Z\u00e1sady komunity',
  'ram.nahlasitProblem': 'Nahl\u00e1sit probl\u00e9m',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Spr\u00e1vce',
  'ot.overenyPravnik': 'Ov\u011b\u0159en\u00fd pr\u00e1vn\u00edk',
  'ot.overenyOdbornik': 'Ov\u011b\u0159en\u00fd odborn\u00edk',
  'ot.odznakJinaZeme': (p) => `Odznak platí jen pro: ${p.zeme}`,
  'ot.otazkyKomunity': 'Ot\u00e1zky komunity',
  'ot.pridatOtazku': 'P\u0159idat ot\u00e1zku',
  'ot.novaOtazka': 'Nov\u00e1 ot\u00e1zka',
  'ot.naCoSeZeptat': 'Na co se chcete zeptat?',
  'ot.otazkaSeZobrazi': 'Va\u0161e ot\u00e1zka se zobraz\u00ed ostatn\u00edm \u010dlen\u016fm komunity, kte\u0159\u00ed na ni mohou odpov\u011bd\u011bt.',
  'ot.otazkaP': 'Ot\u00e1zka *',
  'ot.oblastTema': 'Oblast / t\u00e9ma',
  'ot.vseObecna': 'V\u0161e (obecn\u00e1 ot\u00e1zka)',
  'ot.odeslatOtazku': 'Odeslat ot\u00e1zku',
  'ot.overEmail': 'Pro p\u0159id\u00e1n\u00ed ot\u00e1zky ov\u011b\u0159te sv\u016fj e-mail',
  'ot.zadneOtazky': 'Zat\u00edm \u017e\u00e1dn\u00e9 ot\u00e1zky. Bu\u010fte prvn\u00ed!',
  'ot.hlasu': (p) => mnozne(p.pocet, 'hlas', 'hlasy', 'hlas\u016f'),
  'ot.odpovedi': (p) => mnozne(p.pocet, 'odpov\u011b\u010f', 'odpov\u011bdi', 'odpov\u011bd\u00ed'),
  'ot.zadneOdpovedi': 'Zat\u00edm \u017e\u00e1dn\u00e9 odpov\u011bdi.',
  'ot.napisteOdpoved': 'Napi\u0161te odpov\u011b\u010f\u2026',
  'ot.jenPravnici': 'Na ot\u00e1zky v Pr\u00e1vn\u00ed poradn\u011b odpov\u00eddaj\u00ed ov\u011b\u0159en\u00ed pr\u00e1vn\u00edci a spr\u00e1vci.',
  'ot.smazatOtazku': 'Smazat tuto ot\u00e1zku?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Nab\u00eddky a popt\u00e1vky',
  'cp.zadneNabidky': '\u017d\u00e1dn\u00e9 nab\u00eddky',
  'cp.napsatZpravu': 'Napsat zpr\u00e1vu',
  'cp.nahlasitUzivatele': 'Nahl\u00e1sit u\u017eivatele',
  'cp.nahlasitKoho': (p) => `Nahl\u00e1sit u\u017eivatele ${p.kdo}`,
  'cp.popisteDuvod': 'Popi\u0161te d\u016fvod nahl\u00e1\u0161en\u00ed. Nahl\u00e1\u0161en\u00ed uvid\u00ed spr\u00e1vci.',
  'cp.zustaneteAnonymni': 'Nahl\u00e1\u0161en\u00ed obdr\u017e\u00ed administr\u00e1tor. Vy z\u016fstanete anonymn\u00ed.',
  'cp.duvodP': 'D\u016fvod *',
  'cp.vybertDuvod': 'Vyberte d\u016fvod\u2026',
  'cp.nevhodneChovani': 'Nevhodn\u00e9 chov\u00e1n\u00ed',
  'cp.falesnyProfil': 'Fale\u0161n\u00fd profil',
  'cp.jinyProblem': 'Jin\u00fd probl\u00e9m',
  'cp.popisVolitelny': 'Popis',
  'cp.volitelny': '(voliteln\u00fd)',
  'cp.popisteSituaci': 'Popi\u0161te situaci podrobn\u011bji\u2026',
  'cp.odeslatNahlaseni': 'Odeslat nahl\u00e1\u0161en\u00ed',
  'cp.vyberteDuvodChyba': 'Vyberte d\u016fvod nahl\u00e1\u0161en\u00ed',
  'cp.nahlaseniOdeslano': 'Nahl\u00e1\u0161en\u00ed bylo odesl\u00e1no administr\u00e1torovi',
  'cp.chybaNahlaseni': 'Nepoda\u0159ilo se odeslat nahl\u00e1\u0161en\u00ed',
  'gal.chranenoHeslem': 'Chr\u00e1n\u011bno heslem',
  'gal.soukromi': 'Soukrom\u00ed',
  'gal.nahravam': 'Nahr\u00e1v\u00e1m\u2026',
  'gal.pridatFotku': 'P\u0159idat fotku',
  'gal.nastaveniSoukromi': 'Nastaven\u00ed soukrom\u00ed galerie',
  'gal.verejna': 'Ve\u0159ejn\u00e1',
  'gal.chranenaHeslem': 'Chr\u00e1n\u011bn\u00e1 heslem',
  'gal.jeChranena': 'Tato galerie je chr\u00e1n\u011bna heslem',
  'gal.zadneFotky': 'Zat\u00edm \u017e\u00e1dn\u00e9 fotky. P\u0159idejte svou prvn\u00ed!',
  'gal.otagovat': 'Otagovat u\u017eivatele',
  'gal.hledatUzivatele': 'Hledat u\u017eivatele\u2026',
  'gal.odemcena': 'Galerie odem\u010dena',
  'gal.spatneHeslo': 'Nespr\u00e1vn\u00e9 heslo galerie',
  'gal.nastaveniUlozeno': 'Nastaven\u00ed galerie ulo\u017eeno',
  'gal.fotkaNahrana': 'Fotka nahr\u00e1na!',
  'gal.chybaNahrat': 'Nepoda\u0159ilo se nahr\u00e1t fotku',
  'gal.fotkaSmazana': 'Fotka smaz\u00e1na',
  'gal.jizOtagovan': 'U\u017eivatel je ji\u017e otagov\u00e1n',
  'gal.otagovan': (p) => `Otagov\u00e1n: ${p.kdo}`,
  'gal.chybaTag': 'Nepoda\u0159ilo se p\u0159idat tag',

  'ram.povolit': 'Povolit',
  'ram.oProjektu': 'O projektu',
  'ram.prekladNeovereny': 'Tenhle překlad zatím nečetl nikdo, kdo tím jazykem mluví. Když něco drhne, dej nám vědět.',
  'ram.kontakt': 'Kontakt',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Mapa sv\u011bta \u2013 kliknut\u00edm otev\u0159ete zemi',
  'mapa.priblizit': 'P\u0159ibl\u00ed\u017eit',
  'mapa.oddalit': 'Odd\u00e1lit',
  'mapa.celySvet': 'Zp\u011bt na cel\u00fd sv\u011bt',
  'mapa.chybaNacteni': 'Nepoda\u0159ilo se na\u010d\u00edst mapu',
  'mapa.chybaZkusteSeznam': 'Mapu se nepoda\u0159ilo na\u010d\u00edst. Zkuste seznam zem\u00ed n\u00ed\u017e.',
  'mapa.teprveRoste': 'Bloom tu teprve roste',
  'mapa.napovedaDotyk': 'Mapu posuneš tažením, přiblížíš dvěma prsty, poklepáním nebo tlačítky. Nemusíš ji používat — níž je hledání i celý seznam zemí.',
  'obsah.specialists': (p) => mnozne(p.pocet, 'odborn\u00edk', 'odborn\u00edci', 'odborn\u00edk\u016f'),
  'obsah.organizations': (p) => mnozne(p.pocet, 'organizace', 'organizace', 'organizac\u00ed'),
  'obsah.events': (p) => mnozne(p.pocet, 'akce', 'akce', 'akc\u00ed'),
  'obsah.pageants': (p) => mnozne(p.pocet, 'sout\u011b\u017e', 'sout\u011b\u017ee', 'sout\u011b\u017e\u00ed'),
  'obsah.resources': (p) => mnozne(p.pocet, 'rozcestn\u00edk', 'rozcestn\u00edky', 'rozcestn\u00edk\u016f'),
  'obsah.zaznamu': (p) => `${p.pocet} ${mnozne(p.pocet, 'z\u00e1znam', 'z\u00e1znamy', 'z\u00e1znam\u016f')}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Kde to m\u00e1\u0161 dom\u016f?',
  'domov.popis': 'Podle toho ti Bloom nab\u00eddne obsah, kter\u00fd je ti bl\u00edzko. Prohl\u00ed\u017eet m\u016f\u017ee\u0161 kteroukoli zemi \u2014 '
      + 'domovskou t\u00edm nezm\u011bn\u00ed\u0161. Nikde se nezve\u0159ej\u0148uje a jde kdykoli zm\u011bnit.',
  'domov.preskocit': 'P\u0159esko\u010dit',
  'domov.najitZemi': 'Naj\u00edt zemi\u2026',
  'domov.nicNeodpovida': 'Nic neodpov\u00edd\u00e1. Zkus jin\u00e9 hled\u00e1n\u00ed.',
  'domov.klikniDoMapy': 'M\u016f\u017ee\u0161 taky prost\u011b kliknout na zemi v map\u011b naho\u0159e.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'P\u0159\u00edsp\u011bvek',
  'typ.users': 'U\u017eivatel',
  'typ.specialists': 'Odborn\u00edk',
  'typ.services': 'Nab\u00eddka',
  'typ.articles': 'Pr\u00e1vn\u00ed poradna',
  'typ.questions': 'Ot\u00e1zka komunity',
  'typ.reviews': 'Recenze odborn\u00edka',
  'nav.emailNeoveren': 'E-mail neov\u011b\u0159en',
  'nav.neovereny': 'Neov\u011b\u0159en\u00fd',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'N\u011bco nefunguje',
  'chyba.navrh': 'N\u00e1vrh zlep\u0161en\u00ed',
  'chyba.bezpecnost': 'Bezpe\u010dnostn\u00ed probl\u00e9m',
  'chyba.jiny': 'Jin\u00fd probl\u00e9m',
  'chyba.vyberteTyp': 'Vyberte pros\u00edm typ probl\u00e9mu',
  'chyba.popisteProsim': 'Popi\u0161te pros\u00edm probl\u00e9m',
  'chyba.odeslano': 'Hl\u00e1\u0161en\u00ed odesl\u00e1no, d\u011bkujeme!',
  'chyba.chybaOdeslat': 'Nepoda\u0159ilo se odeslat hl\u00e1\u0161en\u00ed',
  'chyba.napisteNam': 'Napi\u0161te n\u00e1m, co se stalo \u2014 pom\u016f\u017ee n\u00e1m to probl\u00e9m opravit.',
  'chyba.typProblemu': 'Typ probl\u00e9mu',
  'chyba.popisProblemu': 'Popis probl\u00e9mu',
  'chyba.popisPriklad': 'Popi\u0161te co se stalo, co jste o\u010dek\u00e1vali a co se m\u00edsto toho stalo\u2026',
  'chyba.priloha': 'Automaticky p\u0159ilo\u017e\u00edme: aktu\u00e1ln\u00ed str\u00e1nku, \u010das a informace o prohl\u00ed\u017ee\u010di.',
  'chyba.odeslatHlaseni': 'Odeslat hl\u00e1\u0161en\u00ed',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Napi\u0161te obsah\u2026',
  'ed.tucne': 'Tu\u010dn\u00e9 (Ctrl+B)',
  'ed.kurziva': 'Kurz\u00edva (Ctrl+I)',
  'ed.odrazky': 'Odr\u00e1\u017ekov\u00fd seznam',
  'ed.vlozitOdkaz': 'Vlo\u017eit odkaz',
  'ed.vlozitTabulku': 'Vlo\u017eit tabulku',
  'ed.radky': '\u0158\u00e1dky',
  'ed.sloupce': 'Sloupce',
  'ed.vlozit': 'Vlo\u017eit',
  'ed.barva.cerna': '\u010cern\u00e1',
  'ed.barva.seda': '\u0160ed\u00e1',
  'ed.barva.fialova': 'Fialov\u00e1',
  'ed.barva.ruzova': 'R\u016f\u017eov\u00e1',
  'ed.barva.modra': 'Modr\u00e1',
  'ed.barva.zelena': 'Zelen\u00e1',
  'ed.barva.cervena': '\u010cerven\u00e1',
  'ed.barva.oranzova': 'Oran\u017eov\u00e1',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Neplatn\u00fd ov\u011b\u0159ovac\u00ed odkaz.',
  'over.hotovo': 'Tvůj e-mail je ověřený.',
  'over.odkazVyprsel': 'Ov\u011b\u0159ovac\u00ed odkaz je neplatn\u00fd nebo vypr\u0161el.',
  'over.overuji': 'Ov\u011b\u0159uji e-mail\u2026',
  'over.cekejte': 'Pros\u00edm \u010dekejte.',
  'over.overen': 'E-mail ov\u011b\u0159en!',
  'over.plnyPristup': 'Nyn\u00ed m\u00e1te pln\u00fd p\u0159\u00edstup ke v\u0161em funkc\u00edm Bloom.',
  'over.prejitNaBloom': 'P\u0159ej\u00edt na Bloom',
  'over.selhalo': 'Ov\u011b\u0159en\u00ed selhalo',
  'over.zpetNaPrihlaseni': 'Zp\u011bt na p\u0159ihl\u00e1\u0161en\u00ed',
  'oauth.ucetNenalezen': '\u00da\u010det nenalezen',
  'oauth.neexistujeGoogle': 'Pro tento Google \u00fa\u010det neexistuje registrace v Bloom. Nejprve se pros\u00edm zaregistrujte.',
  'oauth.neexistujeFacebook': 'Pro tento Facebook \u00fa\u010det neexistuje registrace v Bloom. Nejprve se pros\u00edm zaregistrujte.',
  'oauth.registrovatGoogle': 'Registrovat p\u0159es Google',
  'oauth.registrovatFacebook': 'Registrovat p\u0159es Facebook',
  'oauth.prihlasujiGoogle': 'P\u0159ihla\u0161ov\u00e1n\u00ed p\u0159es Google\u2026',
  'oauth.prihlasujiFacebook': 'P\u0159ihla\u0161ov\u00e1n\u00ed p\u0159es Facebook\u2026',
  'oauth.facebookSelhalo': 'P\u0159ihl\u00e1\u0161en\u00ed p\u0159es Facebook selhalo',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Na\u010d\u00edt\u00e1m\u2026',
  'obecne.nezadano': '\u2014 nezad\u00e1no \u2014',
  'obecne.neplatnaHodnota': 'Neplatn\u00e1 hodnota.',
  'obecne.strankovani': 'Str\u00e1nkov\u00e1n\u00ed',
  'navrh.doplnteNazev': 'Dopl\u0148te pros\u00edm n\u00e1zev.',
  'navrh.vyberteZemi': 'Vyberte pros\u00edm zemi.',
  'navrh.doplnte': (p) => `Dopl\u0148te pros\u00edm: ${p.co}.`,
  'kat.overenoZaznam': 'Ov\u011b\u0159eno, \u017ee z\u00e1znam odpov\u00edd\u00e1 skute\u010dnosti',
  'kat.prihlaskyDo': (p) => `P\u0159ihl\u00e1\u0161ky do ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profil',
  'profil.zalozkaGalerie': 'Galerie',
  'pf.lokalita': 'Lokalita',

  'cesta.legendaBarev': 'Legenda barev',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${mnozne(p.pocet, 'výsledek', 'výsledky', 'výsledků')})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Dlouh\u00e9 blond vlasy',
  'avatar.fem-lavender': 'Fialov\u00e9 vlasy',
  'avatar.fem-peach': 'Mik\u00e1do s ofinou',
  'avatar.fem-dark': 'Dlouh\u00e9 tmav\u00e9 vlasy',
  'avatar.fem-straight': 'Zrzav\u00e9 vlasy',
  'avatar.fem-ponytail': 'Cul\u00edk',
  'avatar.masc-blue': 'Kr\u00e1tk\u00e9 blond vlasy',
  'avatar.masc-teal': 'Rozcuchan\u00e9 vlasy',
  'avatar.masc-gray': '\u0160ediv\u00e9 vlasy',
  'avatar.masc-short': 'Je\u017eek',
  'avatar.nb-mint': 'M\u00e1tov\u00e9 vlasy',
  'avatar.nb-lilac': 'Drdol naho\u0159e',
  'avatar.nb-curly': 'Kr\u00e1tk\u00e9 kudrny',
  'avatar.nb-sage': 'Polodlouh\u00e9 vlasy',
  'avatar.nb-mohawk': '\u010c\u00edro',
  'avatar.nb-undercut': 'Podholen\u00e9 vlasy',
  'avatar.nb-shaved': 'Vyholen\u00e1 hlava',
  'avatar.nb-glasses': 'Br\u00fdle',
  'avatar.animal-cat': 'Ko\u010dka',
  'avatar.animal-fox': 'Li\u0161ka',
  'avatar.animal-rabbit': 'Kr\u00e1l\u00edk',
  'avatar.sym-flower': 'Kv\u011bt',
  'avatar.sym-butterfly': 'Mot\u00fdl',
  'avatar.sym-star': 'Hv\u011bzda',
  'avatar.custom': 'Nahr\u00e1t vlastn\u00ed foto',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Odhl\u00e1sili jsme t\u011b kv\u016fli ne\u010dinnosti.',
  'odhl.necinnostPopis': 'Bloom nenech\u00e1v\u00e1 p\u0159ihl\u00e1\u0161en\u00ed b\u011b\u017eet, kdy\u017e u toho nikdo nen\u00ed.',
  'odhl.zaChvili': 'Za chv\u00edli t\u011b odhl\u00e1s\u00edme',
  'odhl.zaChviliPopis': 'Kdykoli se dotkni obrazovky nebo kl\u00e1vesnice a z\u016fstane\u0161 p\u0159ihl\u00e1\u0161en\u00e1.',

  'reg.avatarSymboly': 'Symboly',

  'avatar.fem-bun': 'Drdol',
  'avatar.masc-navy': 'Plnovous',
  'avatar.masc-brown': 'Vlasy na stranu',
  'avatar.masc-goatee': 'Bradka',
  'avatar.nb-freckles': 'Pihy',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Sova',
  'avatar.sym-rainbow': 'Duha',
  'avatar.sym-heart': 'Srdce',
  'avatar.sym-lotus': 'Lotos (Bloom)',

  'reg.potvrditHeslo': 'Potvrdit heslo',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Vytvořit',
  'obecne.sdilet': 'Sdílet',
  'obecne.opravneni': 'Oprávnění',
  'obecne.pristupGalerie': 'Pro nahrání fotky potřebujeme přístup k galerii.',
  'obecne.vsechnyRegiony': 'Všechny regiony',
  'obecne.cesko': 'ČR',
  'obecne.odbornici': 'Odborníci',
  'obecne.zadnaZprava': 'Žádná zpráva',
  'ucet.vyplnteEmailHeslo': 'Vyplňte e-mail a heslo',
  'ucet.spatneUdaje': 'Nesprávný e-mail nebo heslo',
  'ucet.googleSelhalo': 'Přihlášení přes Google se nezdařilo',
  'ucet.skrytHeslo': 'Skrýt heslo',
  'ucet.emailOveren': 'E-mail byl úspěšně ověřen!',
  'ucet.emailPriklad': 'váš@email.cz',
  'ucet.overeniSelhalo': 'Ověření se nezdařilo.',
  'ucet.overeniSelhaloZnovu': 'Ověření se nezdařilo. Zkuste to znovu.',
  'ucet.komunitniHesloPovinne': 'Komunitní heslo je povinné',
  'ucet.zadejteKomunitniHeslo': 'Zadejte komunitní heslo…',
  'ucet.komunitniHesloPopis': 'Bloom je soukromý prostor. Heslo ti může předat někdo z komunity.',
  'ucet.prezdivkaMin3': 'Přezdívka musí mít alespoň 3 znaky',
  'ucet.vyplntePrezdivku': 'Vyplňte přezdívku',
  'ucet.vasePrezdivka': 'Vaše přezdívka',
  'ucet.profilNeulozen': 'Nepodařilo se uložit profil',
  'ucet.anoZrusitProfil': 'Ano, zrušit profil',
  'heslo.min8': 'Heslo musí mít alespoň 8 znaků',
  'heslo.maleP': 'Heslo musí obsahovat malé písmeno',
  'heslo.velkeP': 'Heslo musí obsahovat velké písmeno',
  'heslo.cislo': 'Heslo musí obsahovat číslo',
  'heslo.specialni': 'Heslo musí obsahovat speciální znak',
  'heslo.specialniPriklad': 'Heslo musí obsahovat speciální znak (!@#$%)',
  'heslo.napoveda': 'Min. 8 znaků, velké, číslo, speciální',
  'profil.oSobe': 'Krátce o sobě…',
  'profil.zajmenaOna': 'ona/její',
  'profil.zajmenaJine': 'jiné',
  'profil.doplnujiciText': 'Nepovinný doplňující text…',
  'profil.prikladOboru': 'např. plastická chirurgie, rodinné právo…',
  'komunita.soukromiNadpis': 'Chráníme soukromí',
  'komunita.soukromiText': 'Co se sdílí v Bloom, zůstává v Bloom.',
  'komunita.podporaText': 'Bloom je o vzájemné podpoře.',
  'komunita.neniObchod': 'Bloom není obchodní platforma.',
  'komunita.zadneObtezovani': 'Jakékoli obtěžování nemá v Bloom místo.',
  'komunita.oslovovani': 'Oslovujeme každého jeho preferovanými jmény a zájmeny.',
  'komunita.jakakolivEtapa': 'Ať jste na jakékoli etapě své cesty.',
  'prav.kategZdravi': 'Zdraví',
  'prav.kategPravni': 'Právní',
  'prav.kategSocialni': 'Sociální',
  'ot.chybaOdpoved': 'Nepodařilo se odeslat odpověď.',
  'ot.chybaOtazka': 'Nepodařilo se přidat otázku.',
  'zk.napisteKomentar': 'Napište komentář…',
  'zpr.chybaHlasova': 'Nepodařilo se nahrát hlasovou zprávu. Backend:',
  'zpr.chybaObrazek': 'Nepodařilo se nahrát obrázek. Backend:',
  'pod.nabizim': 'Nabízím',
  'pod.coHledate': 'Co hledáte? (např. masáže, fotografie…)',
  'pod.coNabizite': 'Co nabízíte? (např. vaření, účesy…)',
  'pod.lokalitaVolitelna': 'Lokalita (volitelné)',
  'pod.podrobnejsiPopis': 'Podrobnější popis *',
  'pod.vyplnteHledate': 'Vyplňte, co hledáte.',
  'pod.vyplnteNabizite': 'Vyplňte, co nabízíte.',
  'pod.vyplntePopis': 'Vyplňte popis.',
  'pod.zadnePrispevky': 'Nemáte žádné příspěvky. Vytvořte nabídku nebo poptávku.',
  'svet.vybratZemi': 'Vybrat zemi',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Přidat otázku',
  'ot.nadpis': 'Otázky a odpovědi',
  'zk.pridat': 'Přidat příběh',
  'zk.novy': 'Nový příběh',
  'zk.smazat': 'Smazat příběh',
  'zk.zadne': 'Zatím žádné příběhy. Buďte první, kdo sdílí!',
  'akt.zadne': 'Zatím žádné aktuality.',
  'nav.clanky': 'Články',
  'ucet.emailOdeslan': 'E-mail odeslán',
  'ucet.komunitniHeslo': 'Komunitní heslo',
  'ucet.nemateUcet': 'Nemáte účet? Zaregistrujte se',
  'ucet.muzetePrihlasit': 'Nyní se můžete přihlásit.',
  'ucet.zapomenutePopis': 'Zadejte e-mail a pošleme vám odkaz pro obnovení hesla.',
  'profil.oMneVolitelne': 'O mně (volitelné)',
  'profil.prezdivka': 'Přezdívka',
  'profil.telefonVolitelne': 'Telefon (volitelné)',
  'cesta.poznamkaVolitelna': 'Osobní poznámka (volitelná)',
  'okoli.vyberteLokalitu': 'Vyberte lokalitu výše',
  'hled.nadpis': 'Vyhledávání',
  'hled.popis': 'Hledejte napříč celou aplikací – uživatelé, články, příběhy, recenze…',
  'hled.min2': 'Zadejte alespoň 2 znaky pro vyhledávání',
  'pod.vsechnySluzby': 'Všechny služby',
  'domu.clenoveKomunity': 'Členové komunity',
  'zpr.zadneKonverzaceHledat': 'Žádné konverzace. Vyhledejte uživatele výše.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'on/jeho',
  'reg.zajmenaOni': 'oni/jejich',
  'reg.zajmenaOno': 'ono/jeho',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Smazat fotografii',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Nastavte heslo pro galerii',
  'reg.min3znaky': 'Min. 3 znaky',
  'reg.zopakujteHeslo': 'Zopakujte heslo',
  'hled.vBloom': 'Hledat v Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Upravit profil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Vybrat region',
  'obecne.region': 'Region',
  'gal.heslemChranena': 'Heslem chráněná',
  'gal.hesloGalerie': 'Heslo galerie',
  'reset.nastavitHeslo': 'Nastavit heslo',
  'reset.hesloObnoveno': 'Heslo obnoveno!',
  'profil.nenalezen': 'Profil nenalezen',
  'obecne.nebo': 'nebo',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Otevři aplikaci na jednorázové kódy a opiš šest číslic u účtu Bloom. Místo nich můžeš zadat i jeden ze záložních kódů.',
  'auth.sifrovaniNapoveda': 'Máš-li na webu zapnuté šifrování zpráv, aplikace se k takovému účtu zatím nepřihlásí. Použij prosím bloomapp.cz v prohlížeči.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Zobrazit heslo',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Opravdu chcete smazat tuto fotografii?',
  'dvf.zadejteKod': 'Zadejte kód z aplikace',
  'sif.odemknoutAplikaci': 'Odemknout aplikaci',
  'profil.odeslatZnovu': 'Odeslat znovu',
};

export default cs;
